export default {
  shopMng: {
    myShop: 'ร้านค้าของฉัน',
    productPubsub: 'โพสต์สินค้า',
    taskPubsub: 'โพสต์ภารกิจ',
    orderMng: 'จัดการคำสั่งซื้อ',
    myAddress: 'จัดการคลังสินค้า'
  },
  //  我的店铺
  myShop: {
    serialNumber: 'ลำดับ',
    shopName: 'ชื่อร้านค้า',
    shopType: 'ประเภทร้านค้า',
    shopLogo: 'โลโก้ร้าน',
    shopStart: 'เวลาทำการ',
    shopStatus: 'สถานะกิจการ',
    usual: 'เปิดปกติ',
    prohibit: 'ถูกระงับ',
    operate: 'การดำเนินการ',
    inputShopNamePlaceholder: 'ใส่ชื่อร้านค้า',
    selectStatusPlaceholder: 'โปรดเลือกสถานะกิจการ',
    search: 'ค้นหา',
    clear: 'ล้าง',
    shopInfo: 'เกี่ยวกับร้านค้า',
    infoChange: 'ปรับเปลี่ยน',
    shopMainPic: 'แบนเนอร์ร้าน',
    brandSelfStore: 'ร้านค้าจัดการแบรนด์ด้วยตนเอง',

    //  店铺简介
    tel: 'เบอร์โทร',
    people: 'ผู้ติดต่อ',
    address: 'ที่อยู่',
    businessLicense: 'ใบอนุญาตประกอบกิจการ',
    tax: 'เลขประจำตัวผู้เสียภาษี'
  },
  //  商品发布
  productPubsub: {
    addProduct: 'เพิ่มสินค้า',
    picProduct: 'ภาพสินค้า',
    namePro: 'ชื่อสินค้า',
    saleNum: 'ยอดขาย',
    tyep: 'หมวดหมู่',
    status: 'สถานะการตรวจสอบ',
    setStatus: 'สถานะการตั้งค่า',
    operate: 'การดำเนินการ',
    editPro: 'แก้ไขสินค้า',
    viewSpecs: 'ดูรายละเอียดสินค้า',
    repPro: 'เติมสต็อกสินค้า',
    notificationPro: 'แจ้งเตือน',
    putOn: 'วางขาย',
    videoPro: 'วีดิโอสินค้า',
    top: 'ปักหมุด',
    giveaway: 'ของขวัญ',
    statusUsual: 'ผ่านการตรวจสอบ',
    noAuth: 'รอการตรวจสอบ',

    //添加商品
    proBrand: 'แบรนด์สินค้า',
    typeInput: 'รายการหมวดหมู่',
    typePro: 'หมวดหมู่สินค้า',
    ProductType: 'ประเภทสินค้า', // 商品类型 1.5.12 新增
    virtuallyProductType: 'ประเภทสินค้าเสมือนจริง', // 虚拟商品类型
    ordinaryCommodity: 'สินค้าทั่วไป', // 普通商品 1.5.12 新增
    PackageCommodity: 'สินค้าแพ็กเกจ', // 套餐商品 1.5.12 新增
    virtuallyCommodity: 'สินค้าเสมือนจริง', // 虚拟商品 1.5.12 新增
    admissionFee: 'ตั๋ว', // 门票
    electronicRoll: 'คูปองอิเล็กทรอนิกส์', // 电子劵
    site: 'สถานที่จัดงาน', // 场地 1.5.12 新增
    namePro: 'ชื่อสินค้า',
    proSecondTitle: 'หัวข้อย่อยสินค้า',
    proInfo: 'แนะนำสินค้า',
    computerUnit: 'หน่วยสินค้า',
    proKey: 'คำที่ใช้ในการค้นหาสินค้า',
    nextStep: 'ต่อไป',
    lastStep: 'ย้อนกลับ',
    specificationTemplate: 'ข้อมูลจำเพาะ',
    add: 'เพิ่ม',
    clickToUpload: 'อัปโหลด',
    productParameters: 'รายละเอียดสินค้าเพิ่มเติม',
    refreshTheList: 'รีเฟรช',
    salesInformation: 'ข้อมูลการขาย',
    internationalBarcode: 'บาร์โค้ด',
    skuCode: 'เลขSKU',
    supplyPrice: 'ราคาต้นทุนสินค้า',
    suggestedPrice: 'ราคาแนะนำ',
    proStock: 'สินค้าคงคลัง',
    inventoryWarningValue: 'แจ้งเตือนสินค้าคงเหลือ',
    long: 'ยาว (ซม.)',
    width: 'กว้าง (ซม.)',
    height: 'สูง (ซม.)',
    grossWeight: 'น้ำหนัก (กก.)',
    productCode: 'รหัสสินค้า',
    proMainPic: 'ภาพหลักสินค้า',
    proDetail: 'รายละเอียด',
    uploadPic: 'อัปโหลดรูปภาพ',
    basePolicy: 'เงื่อนไขพื้นฐาน',
    fakeOnePayThree: 'เจอสินค้าปลอม ปรับ 3 เท่า',
    brandAfter: 'บริการหลังการขาย',
    fastDelivery: 'จัดส่งรวดเร็ว',
    fastRefund: 'คืนเงินรวดเร็ว',
    chosePolicy: 'เงื่อนไขที่สามารถเลือกได้',
    proFreeShipping: 'รวมค่าจัดส่ง',
    selectShippingWarehouse: 'เลือกคลังสินค้าที่จะจัดส่ง',
    deliveryAddress: 'ที่อยู่จัดส่ง',
    submitProduct: 'เสร็จสิ้นและส่งสินค้า',
    address: 'ที่อยู่', // 地址
    longitudeAndLatitudePrompts: 'โปรดป้อนลองจิจูดและละติจูด'
  },
  //  任务发布
  taskPubsub: {
    searchCondition: 'ตัวกรองค้นหา',
    taskType: 'ประเภทภารกิจ',
    search: 'ค้นหา',
    clear: 'ล้าง',
    dataList: 'ตารางจัดเก็บข้อมูล',
    add: 'เพิ่ม',
    serialNumber: 'ลำดับ',
    picProduct: 'ภาพสินค้า',
    namePro: 'ชื่อสินค้า',
    start: 'เริ่ม',
    end: 'สิ้นสุด',
    operate: 'การดำเนินการ',
    viewDetail: 'ดูรายละเอียด',

    //添加任务
    chosePro: 'เลือกสินค้า',
    growthTool: 'เครื่องมือการเติบโต',
    skuPic: 'ภาพเลขSKU',
    skuPara: 'ค่าพารามิเตอร์SKU',
    priceAdjust: 'ปรับราคา',
    giveawayStock: 'คลังรางวัล',
    startTime: 'เริ่ม',
    endTime: 'สิ้นสุด',
    chooseAProduct: 'เลือกสินค้า สามารถเลือกได้หลายคุณสมบัติ',
    searchSKU: 'ค้นหาเลขSKU',
    pic: 'รูปภาพ',
    param: 'ค่าพารามิเตอร์',
    salePrice: 'ราคาขาย',
    proStock: 'สินค้าคงคลัง',
    taskStock: 'คลังภารกิจ',
    giveawayChose: 'เลือกของขวัญ'
  },
  //  订单管理
  orderMng: {
    searchCondition: 'ตัวกรองค้นหา',
    searchInput: 'ป้อนการค้นหา',
    receiver: 'ผู้รับ',
    submissionTime: 'เวลาส่ง',
    orderStatus: 'สถานะคำสั่งซื้อ',
    orderType: 'ประเภทคำสั่งซื้อ',
    orderSource: 'ที่มาคำสั่งซื้อ',
    search: 'ค้นหา',
    clear: 'ล้าง',
    dataList: 'ตารางจัดเก็บข้อมูล',
    num: 'จำนวน',
    orderNum: 'เลขที่คำสั่งซื้อ',
    putTime: 'เวลาส่ง',
    userNum: 'บัญชีผู้ใช้',
    orderMoney: 'ยอดเงิน',
    payType: 'วิธีการชำระเงิน',
    orderSource: 'ที่มาคำสั่งซื้อ',
    orderStatus: 'สถานะคำสั่งซื้อ',
    operate: 'การดำเนินการ',
    reviewOrder: 'ดู',

    //查看订单
    putOrder: 'ส่งคำสั่งซื้อ',
    userPay: 'ผู้ใช้ชำระเงิน',
    shopShip: 'ร้านค้าจัดส่งสินค้า',
    fastDelivery: 'จัดส่งรวดเร็ว',
    UserReceivesGoods: 'ผู้ใช้รับสินค้า',
    quickServece: 'บริการรวดเร็ว',
    orderTime: 'คำสั่งซื้อหมดอายุแล้ว',
    shopStockUp: 'ร้านค้ากำลังจัดเตรียมสินค้า',
    shipDetail: 'รายละเอียดการจัดส่ง',
    quickPro: 'จัดส่งทันที',
    prsentStatus: 'สถานะการสั่งซื้อปัจจุบัน',
    editOwerInfo: 'แก้ไขรายละเอียดที่อยู่ผู้รับ',
    sendMessage: 'ส่งข้อความ',
    cancelOrder: 'ยกเลิกคำสั่งซื้อ',
    remarkOrder: 'หมายเหตุ',
    orderInfo: 'ข้อมูลคำสั่งซื้อ',
    orderSku: 'หมายเลขคำสั่งซื้อ',
    placeAnOrder: 'เวลาสั่งซื้อ',
    UserID: 'ไอดีผู้ใช้',
    payType: 'วิธีการชำระเงิน',
    orderSource: 'ที่มาคำสั่งซื้อ',
    proPic: 'ภาพสินค้า',
    productName: 'ชื่อสินค้า',
    supplyPrice_: 'ราคาสินค้า/ชิ้น',
    Specification: 'คุณสมบัติ',
    shopDiscount: 'ส่วนลดร้านค้า',
    Subtotal: 'ยอดรวม',
    logisticsInformation: 'ข้อมูลขนส่ง',
    deliveryMethod: 'วิธีการจัดส่ง',
    shipmentNumber: 'เลขที่พัสดุ',
    sumitTime: 'ยืนยันเวลาที่ได้รับสินค้าโดยอัตโนมัติ',
    orderAvailable: 'คำสั่งซื้อนี้สามารถรับเหรียญได้',
    orderAvailableValue: 'คำสั่งซื้อนี้สามารถได้รับค่าการเติบโต',
    activeInfo: 'รายละเอียดกิจกรรม',
    payInfo: 'รายละเอียดการชำระเงิน',
    payType: 'วิธีการชำระเงิน',
    payTime: 'เวลาชำระเงิน',
    supplyPrice: 'ราคาสินค้า',
    freight: 'ค่าจัดส่ง',
    discount: 'ส่วนลด',
    installmentServiceFee: 'บริการผ่อนชำระ',
    tax: 'VAT',
    integral: 'คะแนนสะสม',
    totalPayment: 'ยอดสุทธิ',
    operatInformation: 'ข้อมูลการดำเนินการ',
    num: 'จำนวน',
    operater: 'ผู้ดำเนินการ',
    orderStatus: 'สถานะคำสั่งซื้อ',
    operatHistory: 'ประวัติ',
    operateTime: 'เวลาดำเนินการ',
    remark: 'หมายเหตุ'
  },
  //  仓库管理
  myAddress: {
    addNewAddress: 'เพิ่มคลังสินค้าจัดส่ง',
    num: 'ลำดับ',
    addressName: 'ชื่อคลังสินค้า',
    address: 'ที่อยู่',
    manager: 'ผู้ดูแล',
    tel: 'เบอร์โทร',
    operate: 'การดำเนินการ',
    updateAddress: 'แก้ไขที่อยู่คลังสินค้า',

    //添加仓库
    addAgainIfMore: 'หากแบรนด์มีคลังสินค้าหลายแห่ง โปรดเพิ่มอีกครั้ง',
    whickPlace: 'พื้นที่',
    detailAddress: 'รายละเอียดที่อยู่',
    postCode: 'รหัสไปรษณีย์',
    usualLogis: 'กำหนดค่าขนส่งที่ใช้',
    defaultLogis: 'ค่าเริ่มต้น'
  },
  //  开通店铺
  openShop: {
    myBrand: 'แบรนด์ของฉัน',
    openSelfShop: 'เปิดร้านค้า',
    num: 'ลำดับ',
    brandName: 'ชื่อแบรนด์ (ไอดี)',
    brandName1: 'ชื่อแบรนด์',
    brandLogo: 'โลโก้แบรนด์',
    operateCountry: 'ประเทศที่ดำเนินการ',
    operateType: 'ประเภทการดำเนินการ',
    brandStatus: 'สถานะแบรนด์',
    operate: 'การดำเนินการ',
    brandInfo: 'แนะนำแบรนด์',
    inputPlaceBrand: 'กรอกชื่อแบรนด์',
    waitAuth: 'รอตรวจสอบ',
    usual: 'ปกติ',
    shopLogoNum: 'เลขทะเบียนเครื่องหมายการค้า',
    brandFromCountry: 'แหล่งที่มาของแบรนด์',
    ownerBrand: 'เจ้าของแบรนด์',
    tel: 'เบอร์โทร',
    email: 'อีเมล',
    email1: 'อีเมล',
    evidence: 'หลักฐาน'
  },
  //  资产中心
  assetCenter: {
    REType: 'ประเภทรายรับและรายจ่าย',
    TranCompTime: 'เวลาเสร็จสิ้นการทำธุรกรรม',
    num: 'ลำดับ',
    orderNum: 'หมายเลขคำสั่งซื้อ',
    waterNum: 'หมายเลขซีเรียล',
    TrWdAmount: 'ยอดธุรกรรม/ถอน',
    deductHandFee: 'หักค่าธรรมเนียมการจัดการทั้งหมด',
    actualDepositDisbursementAmount: 'ยอดฝาก/เบิกจ่ายจริง',
    totalAmount: 'จำนวนเงินรวมในบัญชีปัจจุบัน',

    WithdrawalApplicateTime: 'เวลายื่นคำร้องขอถอนเงิน',
    WithdrawalNum: 'หมายเลขคำร้อง',
    amountWithdrawn: 'จำนวนเงินที่สามารถถอนได้',
    applicationWithdrawalAmount: 'จำนวนเงินที่ยื่นคำร้อง',
    WithdrawalFee: 'ค่าธรรมเนียมการถอน',
    actualAmountReceived: 'จำนวนเงินที่ได้รับจริง',
    IDPassportExpirationDate: 'วันหมดอายุบัตรประชาชน/หนังสือเดินทาง',
    CardholderName: 'ชื่อผู้ถือบัตร',
    BankDeposit: 'ธนาคาร',
    BankCardNumber: 'เลขที่บัตรธนาคาร',
    BankCardValidityPeriod: 'วันหมดอายุบัตร',
    applicant: 'ผู้ร้องขอ',
    withdrawalStatus: 'สถานะการถอน',
    actualPaymentAmount: 'ยอดชำระจริง',
    auditOperators: 'ผู้ดำเนินการตรวจสอบ',
    processingCompletionTime: 'เวลาจัดการเสร็จสิ้น',
    operate: 'การดำเนินการ',

    //  新加   6-30
    withdraw: 'ถอนเงิน', //提现
    WithdrawableBalance: 'ยอดเงินที่สามารถถอนได้', //可提现余额
    frozenAmount: 'ยอดเงินที่ถูกระงับไว้', //冻结金额
    bindBankCard: 'ผูกบัตรธนาคาร', //绑定银行卡
    revenueExpenditureRecords: 'ประวัติรายรับ-รายจ่าย', //收支记录
    revenueExpenditureType: 'ประเภทรายรับ-รายจ่าย', //收支类型
    applicationTime: 'เวลายื่นคำขอ', //申请时间
    paymentTime: 'เวลาชำระเงิน', //付款时间
    orderType: 'ประเภทคำสั่งซื้อ', //订单类型
    orderCompletionTime: 'เวลาคำสั่งซื้อเสร็จสิ้น', //订单完成时间
    parentOrderNumber: 'เลขเช็คประวัติคำสั่งซื้อ', //母订单编号
    subOrderNumber: 'เลขพัสดุ', //子订单编号
    afterSalesStatus: 'สถานะบริการหลังการขาย', //售后状态
    afterSalesApplicationTime: 'เวลายื่นคำขอ', //售后申请时间
    afterSalesOrderNumber: 'เลขที่คำขอ' //售后单编号
  },
  //  活动管理
  activeMng: {
    filterSearch: 'ตัวกรองค้นหา',
    inputSearch: 'ป้อนการค้นหา',
    clear: 'ล้าง',
    search: 'ค้นหา',
    activeName: 'ชื่อกิจกรรม',
    activeStart: 'เริ่มกิจกรรม',
    founder: 'ผู้สร้าง',
    activeCreate: 'เวลาสร้างกิจกรรม',
    activeStatus: 'สถานะกิจกรรม',
    authStatus: 'สถานะการตรวจสอบ',
    activeSecondTitle: 'หัวข้อย่อยกิจกรรม',
    listPic: 'รูปภาพ',
    detailPic: 'ภาพรายละเอียด',
    taskPro: 'สินค้าภารกิจ',
    levelAward: 'รางวัลด่าน',
    activeSecondTitle: 'เพิ่มสินค้า',
    choseLevelAward: 'เลือกของขวัญด่าน',
    choseNumAward: 'เลือกรางวัลอันดับ',
    endNum: 'อันดับสิ้นสุด',
    startNum: 'อันดับเริ่มจาก'
  },
  //  活动审核
  activeAuth: {
    activeList: 'ตารางกิจกรรม',
    startTime: 'เริ่มกิจกรรม',
    endTime: 'สิ้นสุดกิจกรรม',
    validityPeriod: 'ระยะเวลากิจกรรม',
    activeName: 'ชื่อกิจกรรม',
    operateTime: 'เวลาดำเนินการ',
    productStock: 'คลังสินค้าพร้อมใช้งาน',
    activeTaskStock1: 'คลังสินค้า',
    activeTaskStock2: 'สินค้ารางวัลด่าน',
    activeTaskStock: 'รางวัลอันดับ',

    brand: 'แบรนด์',
    shopNum: 'รหัสร้านค้า',
    activeEndTime: 'สิ้นสุดกิจกรรม',
    activeAuthPeople: 'ผู้ดำเนินการตรวจสอบ',
    proStatus: 'สถานะสินค้า'
  },
  //  用户列表
  userAuth: {
    inputPlaceUserName: 'โปรดกรอกชื่อผู้ใช้',
    inputPlaceAnthStatus: 'โปรดเลือกสถานะการตรวจสอบ',
    userName: 'ชื่อ',
    pass: 'ผ่าน',
    reject: 'ปฏิเสธ',

    userList: '用户列表'
  },
  //  商家端字段补充
  merchant: {
    trademarkRights: 'สัญญาอนุญาตให้ใช้เครื่องหมายการค้า', //商标权限
    withdrawNum: 'เลขการถอนเงิน', //提现单号
    withdrawType: 'ประเภทการถอนเงิน', //提现打款方式
    withdrawOprateTime: 'ระยะเวลาการตรวจสอบ', //审核操作时间
    IDCardName: 'ชื่อผู้ถือบัตร', //持卡人姓名
    IDCardBank: 'ธนาคาร', //开卡银行
    bankNum: 'เลขบัญชี', //银行账号
    export: 'ดึงข้อมูล', //导出
    IDname: 'ชื่อบนบัตรประชาชน/หนังสือเดินทาง', //身份证/护照姓名
    IDnum: 'หมายเลขบัตรประชาชน/หนังสือเดินทาง', //身份证/护照编号
    businessLicenseFront: 'อัปโหลดใบอนุญาตประกอบกิจการ (ด้านหน้า)', //上传营业执照（正面）
    taxFileNumberFront: 'เอกสารผู้เสียภาษี (ด้านหน้า)', //税号文件（正面）
    add: 'เพิ่ม', //新增
    itemNo: 'หมายเลขรายการสินค้า', //货号
    taskName: 'ชื่อภารกิจ', //任务名称
    shippingSettings: 'ตั้งค่าค่าจัดส่ง', //运费设置
    freeShipping: 'ฟรีค่าจัดส่ง', //包邮
    shippingTemplate: 'รูปแบบค่าจัดส่ง', //运费模板
    selectedItems: 'สินค้าถูกเลือกแล้ว', //已选择的商品
    selectedGifts: 'ของขวัญถูกเลือกแล้ว', //已选择的赠品
    selectedPro: 'เลือกสินค้า', //选择商品
    selectedGifts2: 'เลือกของขวัญ', //选择赠品
    inputProName: 'กรุณาใส่ชื่อสินค้า', //请输入商品名称
    proBarcode: 'บาร์โค้ดสินค้า', //商品条码
    addNewStorehouse: 'เพิ่มคลังสินค้า', //新增发货仓库
    cancel: 'ยกเลิก', //取 消
    confirm: 'ยืนยัน', //确 定
    prizeSupplyPrice: 'ราคาขายของรางวัล', //奖品供货价
    submit: 'ส่ง', //提交
    productNumber: 'รหัสสินค้า', //商品编号
    lengthWidthHeight: 'ยาว*กว้าง*สูง(ซม.)', //长*宽*高(cm)
    harvestAddress: 'ที่อยู่จัดส่ง', //收货地址
    distributionPackage: 'แบ่งกล่องพัสดุ', //分配包裹
    shippingMethod: 'วิธีการจัดส่ง', //运送方式
    logisticsCompanyName: 'ชื่อบริษัทขนส่ง', //物流公司名称
    shippingBillNumber: 'เลขพัสดุ', //发货运单号
    addPackage: 'เพิ่มกล่องพัสดุ', //添加包裹
    userReceiptInformation: 'ข้อมูลผู้รับสินค้า', //用户收货信息
    latestDeliveryLeft: 'เหลือเวลาในการจัดส่งอีก', //最晚发货还剩
    totalCurrentOrder: 'คำสั่งซื้อทั้งหมดในตอนนี้', //当前订单共
    items: 'ชิ้น', //件商品
    inputBrandName: 'ใส่ชื่อแบรนด์', //输入品牌名称

    // 629
    uploadFail10mb: 'กรุณาอัปโหลดไฟล์ ขนาดไม่เกิน 3 MB', //请上传文件，且不超过10MB
    evidenceFails: 'สัญญาอนุญาตให้ใช้เครื่องหมายการค้า หนังสือรับรองการจดทะเบียนเครื่องหมายการค้า หนังสือมอบอำนาจจากแบรนด์', //商标受理通知书，商标注册证书，品牌授权书
    owner1: 'บุคคลธรรมดา', //个人
    owner2: 'นิติบุคคล', //企业
    TrademarkRights1: 'เป็นเจ้าของแบรนด์โดยสมบูรณ์', //完全持有商标
    TrademarkRights2: 'กิจการร่วมค้า', //授权合资公司
    TrademarkRights3: 'ตัวแทนแบรนด์ต่างประเทศ', //授权国代
    tai: 'ไทย +66', //泰国+66
    zh: 'จีน +86', //中国+86
    en: 'สหรัฐอเมริกา +1', //美国+1
    inputTrueInfo: 'กรุณายืนยันว่าข้อมูลที่ท่านให้เป็นความจริง', //请确保您填写的信息真实有效
    inputTrueInfoText: 'กรุณาเขียนแนะนำร้านค้าของท่าน ข้อมูลนี้จะแสดงในหน้าประวัติย่อแบรนด์บนแอปพลิเคชัน', //请填写店铺介绍，这将展示App品牌店铺简介
    inputInfoTextLookOut: 'คำเตือน: สามารถแก้ไขได้เพียงเดือนละ 1 ครั้งเท่านั้น กรุณาตรวจสอบความถูกต้อง', //注意：每月仅限修改一次，请认真填写
    enterAndCheckTheTaxID: 'กรอกเลขประจำตัวผู้เสียภาษีและตรวจสอบความถูกต้อง', //输入并核对税号
    categoriesSelectedFitWithinRange: 'ประเภทที่เลือกจะต้องสอดคล้องกับขอบเขต"สินค้าและบริการ" มิฉะนั้นอาจตรวจสอบไม่ผ่าน', //选择的分类必须符合商标的"商品/服务"范围，否则审核可能不通过
    pleaseSelect: 'กรุณาเลือก', //请选择
    pleaseUpload: 'กรุณาอัปโหลด', //请上传
    areaCode: 'รหัสประเทศ', //区号
    brandCountry: 'ประเทศของแบรนด์', //品牌国家
    placeOrigin: 'สถานที่ผลิต', //产地
    home: 'ในประเทศ', //国内
    entrance: 'นำเข้า', //进口
    SuchPieceBox: 'เช่น อัน ชิ้น กล่อง', //如个、件、箱
    inputSelectTierDistrict1: 'กรุณาเลือกจังหวัด', //请选择一级行政区
    inputSelectTierDistrict2: 'กรุณาเลือกเขต/อำเภอ', //请选择二级行政区
    inputSelectTierDistrict3: 'กรุณาเลือกแขวง/ตำบล', //请选择三级行政区
    inputUnitMeasurement: 'กรุณากรอกหน่วยวัด', //请输入计量单位
    inputItemNumber: 'กรุณากรอกรหัสสินค้า', //请输入商品编号
    inputFreightTemplate: 'กรุณาเลือกรูปแบบค่าจัดส่ง', //请选择运费模板
    newFreightTemplate: 'สร้างรูปแบบค่าจัดส่ง', //新建运费模板
    refreshFreightTemplate: 'รีเฟรชรูปแบบค่าจัดส่งล่าสุด', //刷新最新运费模板
    overtimeFree: 'การันตีเวลาจัดส่ง', //超时免单
    basicPolicyTitle1: 'เงื่อนไขพื้นฐานข้างต้นไม่สามารถยกเลิกได้', //基本政策为必选项，不可取消
    basicPolicyTitle2: 'สามารถเลือกเงื่อนไขได้ตามสถานการณ์จริง', //针对实际情况选择可选政策
    basicPolicyTitle3: 'การันตีเวลาจัดส่ง: จัดส่งเกิน 7 วันยินดีคืนเงิน', //请务必根据商品所在仓库进行选择
    nameConsignee: 'ชื่อผู้รับ/เบอร์โทร', //收货人姓名/手机号码
    all: 'ทั้งหมด', //全部
    choseTime: 'กรุณาเลือกเวลา', //请选择时间
    merchandiseOrder: 'คำสั่งซื้อ', //商品订单
    afterSaleOrder: 'บริการหลังการขาย', //售后订单
    brandMultipleDeliveryWarehousesText: 'หากแบรนด์มีคลังสินค้าหลายแห่ง กรุณาเพิ่มข้อมูลคลังสินค้า', //品牌若存在多个发货仓库请重新添加
    addNewWarehouseText: 'เพิ่มคลังสินค้า', //新增发货仓库
    shopWater: 'ค่าใช้จ่ายร้านค้า', //店铺流水
    withdrawList: 'ประวัติการถอนเงิน', //提现记录
    traList: 'ประวัติการทำธุรกรรม', //交易记录

    //  630--之后
    withdraw: 'ยอดการถอนเงิน', //提现金额
    goBack: 'กลับ', //返回
    withdrawChoseBank: 'เลือกบัตรธนาคาร', //选择银行卡
    couldwidthdraw: 'บัญชีนี้สามารถถอนเงินได้', //当前账户可提现金额
    allwidthdraw: 'ถอนทั้งหมด', //全部提现
    confirmWidthdraw: 'ยืนยัน', //确认提现
    widthdrawRules: 'ระเบียบการถอนเงิน', //提现规则
    widthdrawRules1: '1.เงินเข้าบัญชีภายใน 24 ชั่วโมง หากถอนเงินในช่วงวันหยุดนักขัตฤกษ์จะได้รับในวันทำการ', //1.提现打款周期为每周一次，每周五统一打款，如申请时间在打款时间之后，顺延到下个打款周期，请合理安排时间
    widthdrawRules2: '2.เนื่องจากเป็นบริการชำระเงินผ่านบุคคลที่สาม จึงเก็บค่าธรรมเนียมการถอนเงิน 3% โดยทางแพลตฟอร์มมีโบนัสสำหรับร้านค้าที่เข้าร่วมในปีแรกจะได้รับการยกเว้นค่าธรรมเนียม ค่าธรรมเนียมการถอนเงินเป็น 0', //2.因提现为第三方支付公司提供服务，按照服务标准提现需要收取提现金额3%的手续费，现平台给出红利，商家首年入驻免费，提现手续费暂定为0
    bankMng: 'จัดการบัตรธนาคาร', //银行卡管理
    bankMngTitle: 'กรุณากรอกข้อมูลบัญชีให้ถูกต้อง หากเกิดข้อผิดพลาดที่มาจากการกรอกข้อมูลไม่ถูกต้องซึ่งนำไปสู่ข้อผิดพลาดในบัญชี แพลตฟอร์มจะไม่รับผิดชอบใดๆ ทั้งสิ้น', //请仔细填写账户信息，如果由于您填写错误导致资金流失，平台概不负责
    acquiesce: 'ค่าเริ่มต้น', //默认
    addBank: 'เพิ่มบัตรธนาคาร', //新增银行卡
    idcardType: 'ประเภท', //证件类型
    idcardName: 'ชื่อ - สกุล ตามบัตรประชาชน', //身份证姓名
    idcardNum: 'เลขที่ประจำตัวประชาชน', //身份证号码
    idcardTime: 'วันหมดอายุ', //身份证有效期
    bankName: 'ชื่อธนาคาร', //银行名称
    getVerifyNum: 'รับ OTP', //获取验证码
    noteCheck: 'กรุณาตรวจสอบ', //请注意查收！
    noteCheck2: 'SMS ยืนยันตัวตน', //短信验证
    noteCheckToPhone: 'ส่ง SMS ยืนยันตัวตนไปยังเบอร์โทรศัพท์ที่ผูกกับบัญชีแล้ว', //验证短信将发送至您当前账号绑定的手机号
    suggestRetailPrice: 'แนะนำราคาขายปลีก', //建议零售价
    quantitySold: 'ยอดขาย', //销售数量
    orderMoney: 'ราคาขายส่ง', //订单供货金额
    channelSaleServiceFee: 'ค่าบริการช่องทางการขาย', //渠道销售服务费
    ThreeFee: 'ค่าธรรมเนียมการชำระเงินผ่านบุคคลที่สาม', //第三方支付手续费
    chouponFee: 'ยอดหักคูปอง', //优惠券抵扣金额
    activitiFee: 'ค่าบริการรางวัลกิจกรรม', //活动奖励服务费
    saleInFee: 'ยอดโอนเข้าบัญชี', //销售入账金额
    saleAfterCode: 'เลขที่คำขอบริการหลังการขาย', //售后单号
    saleAfterSupplyGoodsFee: 'คืนราคาส่ง', //售后退回供货金额
    AfterSaleRefundChannelSaleServiceFee: 'คืนค่าบริการช่องทางการขาย', //售后退回渠道销售服务费
    makeAmountDeductedCoupon: 'คืนยอดเงินที่หักคูปอง', //补回优惠券抵扣金额
    returnFreight: 'คืนค่าจัดส่ง', //售后退回运费
    rewardServiceFeeAfterSaleActivity: 'คืนค่าบริการรางวัลกิจกรรม', //售后退回活动奖励服务费
    totalAmountReturnedAfterSale: 'คืนเงินทั้งหมด', //售后退回总金额
    settlementAmount: 'ยอดสุทธิ', //结算金额
    totalStockIncludReplenishment: 'สินค้าทั้งหมดในคลัง (รวมยอดเติมสต็อก)', //商品总库存（包含补货）
    activeLockInventory: 'ล็อกสต็อกกิจกรรม', //活动锁定库存
    remainAvailableStock: 'คลังสินค้าที่ใช้ได้เหลืออยู่', //剩余可用库存
    inventoryWarningQuantity: 'จำนวนแจ้งเตือนสต็อก', //库存预警数量
    WarniTime: 'เวลาแจ้งเตือน', //预警时间
    Tips: 'แจ้งให้ทราบ', //提示
    TipsContent: 'ค่าธรรมเนียมการจัดส่งที่เรียกเก็บระหว่างการทำธุรกรรมจะคำนวณตามการตั้งค่ารูปแบบการจัดส่งที่เลือกไว้เมื่อลงรายการสินค้า ท่านสามารถเพิ่มได้', //交易过程中收取的运费会根据发布商品时选择的运费模板设置来计算，您还可以添加
    freeShipUnderSpecifieCondition: 'จัดส่งฟรีตามเงื่อนไขที่กำหนด', //指定条件包邮
    lastEditTime: 'แก้ไขล่าสุด', //最后编辑时间
    copyOne: 'คัดลอกรูปแบบ', //复制模板
    detail: 'รายละเอียด', //详情
    edit: 'แก้ไข', //编辑
    del: 'ลบ', //删除
    delBatch: 'ลบหลายรายการ', //批量删除
    transport: 'วิธีการจัดส่ง', //运送方式
    canShipped: 'สามารถจัดส่งได้ที่', //可运送至
    firstPiece: 'ชิ้นแรก', //首件
    addFre: 'เพิ่มค่าจัดส่ง', //增加运费
    defaultFre: 'ค่าจัดส่งเริ่มต้น', //默认运费
    successor: 'ชิ้นถัดไป', //续件
    renew: 'ราคาถัดไป', //续费
    py: 'ลงทะเบียน', //平邮
    kd: 'จัดส่งด่วน', //快递
    tgyz: 'ไปรษณีย์ไทย', //泰国邮政
    TemplateName: 'ชื่อรูปแบบ', //模板名称
    pricingMethod: 'วิธีการคำนวณ', //计价方式
    typeNumber: 'ตามจำนวน', //按件数
    typeWeight: 'ตามน้ำหนัก', //按重量
    typeV: 'ตามขนาด', //按体积
    addOne: 'เพิ่มขึ้นทุก', //每增加
    batchSet: 'ตั้งค่าหลายรายการ', //批量设置
    batchOperate: 'จัดการหลายรายการ', //批量操作
    goTo: 'ส่งถึง', //运送至
    shipSpecifiedCity: 'ตั้งค่าค่าจัดส่งตามพื้นที่', //为指定地区城市设置运费
    firstNum: 'ชิ้นแรก (ชิ้น)', //首件（件）
    firstFee: 'ราคา (บาท)', //首费（铢）
    secondNum: 'ชิ้นถัดไป (ชิ้น)', //续件（件）
    secondFee: 'ราคาถัดไป (บาท)', //续费（铢）

    // 优惠券
    addCoupon: 'เพิ่มคูปอง', //添加优惠券
    CouponsTipContent: 'คูปองแบ่งเป็นแบบมีเกณฑ์และไม่มีเกณฑ์การใช้คูปอง หน้าที่หลัก คือ การเพิ่มราคาต่อหน่วยของลูกค้า เพิ่มอัตราการกลับมาซื้อซ้ำ และดึงดูดลูกค้าเก่าและใหม่ให้มาซื้อกันมากขึ้น', //优惠券分为有门槛和无门槛优惠券，主要作用有提升客单价、提高回购率、吸引新老顾客形成购买转化。
    couponsFace: 'ข้อมูลหน้าคูปอง', //优惠券券面信息
    couponsName: 'ชื่อคูปอง', //优惠券名称
    font60: 'สูงสุดไม่เกิน 60 ตัวอักษร', //最多不超过60个字符
    font100: 'สูงสุดไม่เกิน 100 ตัวอักษร', // 最多不超过100个字符
    faceVal: 'มูลค่า', //面值
    useConditions: 'เงื่อนไขการใช้', //使用条件
    NoLimit: 'ไม่จำกัด', //不限制
    orderAll: 'ยอดสั่งซื้อครบ', //订单满
    validityPeriod: 'วันหมดอายุ', //有效期限
    groundRules: 'ระเบียบพื้นฐาน', //基本规则
    TotalAmountIssued: 'จำนวนทั้งหมด', //发放总量
    CouponRestriction: 'ข้อจำกัดการรับคูปอง', //领券限制
    BahtCanUsed: 'บาท ที่สามารถใช้ได้', //铢，可使用
    zhang: 'ใบ', //张
    maximumNumberCoupons: 'ผู้ใช้แต่ละรายสามารถรับคูปองด้วยตนเองตามจำนวนสูงสุด หากไม่เลือก จะได้รับ 1 ใบเป็นค่าเริ่มต้น', //每个用户自助领券上限，如不选，则默认为1张
    allProJoin: 'สินค้าทั้งหมดที่เข้าร่วม', //全部商品参与
    NewlyReleasedProductsAdaptRule: 'แจ้งให้ทราบ: สินค้าใหม่เป็นไปตามระเบียบนี้เช่นกัน', //提示：新发布的商品也能适应此规则
    PartialProJoin: 'สินค้าบางส่วนที่เข้าร่วม', //部分商品参与
    remove: 'เอาออก', //移除
    save: 'บันทึก', //保存
    goWhich: 'ถึง', //至
    addCoupon: 'เพิ่มคูปอง', //新增优惠券
    BatchCancellation: 'ปิดการใช้งานหลายรายการ', //批量作废
    claimRestriction: 'ข้อจำกัดการรับ', //领取限制
    PiecePerson: 'ใบ/คน', //张/人
    stock: 'คลังสินค้า', //库存
    Claimed: 'รับแล้ว', //已领取
    haveUsed: 'ใช้แล้ว', //已使用
    status: 'สถานะ', //状态
    proApply: 'สินค้าที่เกี่ยวข้อง', //适用商品
    proEdit: 'แก้ไขสินค้า', //修改商品
    cancellation: 'ปิดการใช้งาน', //作废
    chosedPro: 'สินค้าที่เลือก', //已选商品
    piece: 'ชิ้น', //件

    // 优惠券遗漏
    collectionTime: 'เวลาที่รับ', //领取时间
    useStatus: 'สถานะการใช้', //使用状态
    useTime: 'เวลาที่ใช้', //使用时间
    couponType: 'ประเภทคูปอง', //优惠券类型
    receiver: 'ผู้รับ', //领取人
    receiveNum: 'จำนวนที่รับ', //领取数量
    detailAfterSaleOrder: 'รายละเอียดคำขอบริการหลังการขาย', //售后单详情
    batchOpen: 'เปิดใช้งานหลายรายการ', //批量启用
    enable: 'เปิดใช้งาน', //启用
    couponManagement: 'จัดการคูปอง', //优惠券管理
    afterSavCoupon: 'หลังจากบันทึกคูปองแล้ว จะสามารถแก้ไขได้เพียงจำนวนคูปองและข้อจำกัดการรับคูปองเท่านั้น กรุณาตรวจสอบความถูกต้องก่อนบันทึก', //优惠券保存后，只能对发放总量和领券限制做编辑修改，请谨慎操作
    receiptRecord: 'ประวัติการรับ/ใช้งาน', //领用/使用记录
    voidCoupon: 'คูปองที่ปิดการใช้งาน' //作废优惠券
  },
  //  商家端校验信息74
  merchantVerify: {
    pleaseSelectTrademarkRight: 'กรุณาเลือกสัญญาอนุญาตให้ใช้เครื่องหมายการค้า', //请选择商标权限
    pleaseSelectCountry: 'กรุณาเลือกประเทศ', //请选择国家
    messageFontLong: 'ความยาวตั้งแต่ 2 ถึง 140 ตัวอักษร', //长度在 2 到 140 个字符
    pleaseUploadLogoPicture: 'กรุณาอัปโหลดรูปเครื่องหมายการค้า', //请上传商标图片
    PleaseEnterTrademarkRegistration: 'กรุณากรอกเลขทะเบียนเครื่องหมายการค้า', //请输入商标注册号
    PleaseSelectBrandOwner: 'กรุณาเลือกเจ้าของแบรนด์', //请选择品牌所有人
    PleaseEnterPhoneNumber: 'กรุณากรอกเบอร์โทรศัพท์', //请输入手机号
    PleaseEnterEmail: 'กรุณากรอกอีเมล', //请输入邮箱
    PleaseSupportingMaterials: 'กรุณาเพิ่มเอกสารหลักฐาน', //请添加证明材料
    PleaseEnterCode: 'กรุณากรอกรหัสพื้นที่', //请输入区号
    PleaseEnterContactPerson: 'กรุณากรอกผู้ติดต่อ', //请输入联系人
    PleaseSelectFirstDistrict: 'กรุณาเลือกเขต/อำเภอ', //请选择一级行政区
    PleaseSelectSecondDistrict: 'กรุณาเลือกแขวง/ตำบล', //请选择二级行政区
    PleaseSelectThirdDistrict: 'กรุณาเลือกจังหวัด', //请选择三级行政区
    PleaseEnterStoreDescription: 'กรุณาเขียนแนะนำร้านค้า', //请输入店铺简介
    PleaseUploadBusinessLicense: 'กรุณาอัปโหลดใบอนุญาตประกอบกิจการ', //请上传营业执照
    PleaseUploadTaxIDFile: 'กรุณาอัปโหลดใบทะเบียนภาษีมูลค่าเพิ่ม (ภ.พ.20)', //请上传税号文件
    PleaseEnteTaxID: 'กรุณากรอกเลขที่ประจำตัวผู้เสียภาษี', //请输入税号
    PleaseUploadStoreLogo: 'กรุณาอัปโหลดโลโก้ร้านค้า', //请上传店铺商标
    PleaseSelectProductCategory: 'กรุณาเลือกประเภทสินค้า', //请选择商品分类
    PleaseSelectCategoryEntry: 'กรุณาเลือกหมวดหมู่สินค้า', //请选择分类入口
    PleaseSelectProperty: 'กรุณาเลือกประเภทสินค้า', //   请选择商品类型 1.5.12新增
    PleaseSelectVirtualGoods: 'กรุณาเลือกประเภทสินค้าเสมือนจริง', // 请选择虚拟商品类型
    PleaseEnterProductName: 'กรุณากรอกชื่อสินค้า', //请输入商品名称
    PleaseEnterUnitMeasurement: 'กรุณากรอกหน่วยวัด', //请输入计量单位
    PleaseEnterProductSubtitle: 'กรุณากรอกหัวข้อย่อยสินค้า', //请输入商品副标题
    PleaseEnterSite: 'กรุณากรอกที่อยู่', // 请输入场地
    PleaseUploadProductMasterMap: 'กรุณาอัปโหลดภาพหลักสินค้า', //请上传商品主图
    PleaseEnterProductCode: 'กรุณากรอกรหัสสินค้า', //请输入商品编码
    PleaseEnterSalesInformation: 'กรุณากรอกรายละเอียดการขาย', //请输入销售信息
    UploadProductDetailsMap: 'อัปโหลดภาพรายละเอียดสินค้า', //上传商品详情图
    messageFontLong2140: 'ความยาวตั้งแต่ 2 ถึง 140 ตัวอักษร', //长度在 2 到 140 个字符
    PleaseEnterPriceItem: 'กรุณากรอกราคาสินค้า', //请输入商品售价
    PleaseSelectProductBrand: 'กรุณาเลือกแบรนด์', //请选择商品品牌
    PleaseEnterProductDescription: 'กรุณาเขียนแนะนำสินค้า', //请输入商品介绍
    fieldRequired: 'ไม่สามารถละเว้นเนื้อหาในช่องนี้ได้', //该项为必填项
    PleaseEnterTaskName: 'กรุณากรอกชื่อภารกิจ', //请输入任务名称
    PleaseEnterStartDate: 'กรุณากรอกวันและเวลาเริ่ม', //请输入开始日期
    PleaseEnterEndDate: 'กรุณากรอกวันและเวลาสิ้นสุด', //请输入结束日期
    RealNameAuthenticationInformation: 'ข้อมูลการยืนยันตัวตน', //实名认证信息
    RealNameAuthentication: 'ยืนยันตัวตน', //实名认证
    bankCard: 'บัตรธนาคาร', //银行卡
    confirmInfo: 'ยืนยันข้อมูล', //确认信息
    activityPro: 'สินค้ากิจกรรม', //活动商品
    logisticsCompany: 'ชื่อบริษัทขนส่ง', //物流公司
    logisticsCompanyCode: 'โค้ดบริษัทขนส่ง',
    logisticsCompanyLogo: 'ชื่อบริษัทขนส่งLogo',

    hour: 'ชั่วโมง', //时
    min: 'นาที', //分
    second: 'วินาที', //秒
    salesRevenue: 'รายได้จากการขาย', //销售收入
    submitApplication: 'ส่งคำขอ', //提交申请
    LookOnMove: 'ข้อมูลแสดงบนแอปพลิเคชัน', //移动端详情
    PleaseSelectDocumentType: 'กรุณาเลือกประเภท', //请选择证件类型
    IdentificationCard: 'บัตรประชาชน', //身份证
    passport: 'หนังสือเดินทาง', //护照
    ChannelSalesServiceFee: 'ค่าบริการช่องทางการขาย', //渠道销售服务费
    ThirdPaymentCommission: 'ค่าธรรมเนียมการชำระเงินผ่านบุคคลที่สาม', //第三方支付手续费
    AmountDeductedMerchantCoupon: 'ยอดหักคูปองร้านค้า', //商家优惠券抵扣金额
    PlatformCouponDiscountAmount: 'ยอดหักคูปองแพลตฟอร์ม', //平台优惠券优惠金额
    QuantityAfterSaleOrder: 'จำนวนคำขอ', //售后单数量
    AmounMerchantCoupon: 'คืนยอดเงินที่หักคูปอง', //补回商家优惠券抵扣金额
    AmountPlatformCouponReturnedSale: 'คืนยอดเงินที่หักคูปองแพลตฟอร์ม', //售后退回平台优惠券优惠金额
    PassportName: 'ชื่อ-สกุลตามหนังสือเดินทาง', //护照姓名
    PassportNumber: 'เลขที่หนังสือเดินทาง', //护照号码
    PassportValidityPeriod: 'วันหมดอายุ', //护照有效期
    SelectDate: 'เลือกวัน', //选择日期
    close: 'ปิด', //关 闭
    BrandSelfOperatStore: 'ร้านค้าที่แบรนด์ดูแล', //品牌自营业店铺
    AfterSaleReceived: 'รอรับสินค้า', //售后待收货
    refunded: 'คืนเงิน', //待退款
    AfterSaleCompletion: 'สิ้นสุดการบริการ', //售后完结
    due: 'รอชำระเงิน', //待付款
    GoodsWaitSent: 'รอจัดส่ง', //待发货
    shipped: 'จัดส่งแล้ว', //已发货
    sendOutGoods: 'การจัดส่งสินค้า', // 发货  1.5.12新增
    completed: 'เสร็จสิ้นแล้ว', //已完成
    TargetClosed: 'ปิดแล้ว', //已关闭
    InvalidOrder: 'คำสั่งซื้อหมดอายุ', //无效订单
    H5Order: 'คำสั่งซื้อผ่าน H5', //H5订单
    RegularOrder: 'คำสั่งซื้อทั่วไป', //正常订单
    AppOrder: 'คำสั่งซื้อผ่านแอปพลิเคชัน', //APP订单
    TaskDistributOrder: 'คำสั่งซื้อภารกิจได้ส่วนแบ่ง', //任务分润订单
    TaskRewardOrder: 'คำสั่งซื้อรางวัลภารกิจ', //任务奖励订单
    RankingGrandPrizeAwardsOrder: 'คำสั่งซื้อรางวัลใหญ่จัดอันดับ', //排名大奖奖励订单
    chosePlace: 'เลือกพื้นที่', //选择地区
    setShip: 'ตั้งค่าเงื่อนไขส่งฟรี', //设置包邮条件
    WithinThe: 'ภายใน' //内
  },
  //  运营端字段补充74
  operationEnd: {
    userList: 'รายการผู้ใช้', //用户列表
    brandList: 'รายการแบรนด์', //品牌列表
    brandPlaceholder: 'กรุณากรอกชื่อแบรนด์', //请输入品牌名称

    //7-6
    BrandEntry: 'แบรนด์เข้าร่วม', //品牌录入
    ActivateStore: 'เปิดใช้งาน', //激活店铺
    DeterministicClassification: 'ยืนยันประเภท', //确定分类
    NotYetStarted: 'ยังไม่เริ่ม', //未开始
    UnderWay: 'กำลังดำเนินการ', //进行中
    AlreadyEnded: 'สิ้นสุดแล้ว', //已结束
    AuditRejection: 'ถูกปฏิเสธ', //审核拒绝
    audited: 'ตรวจสอบแล้ว', //已审核
    CorporateTransfer: 'บริษัทโอนไปยังบัญชี', //公司转账
    DirectWithdrawal: 'ถอนเงินทันที', //直接提现
    InApplication: 'อยู่ระหว่างยื่นคำขอ', //申请中
    SuccessfulWithdrawal: 'ถอนเงินสำเร็จ', //提现成功
    WithdrawalFailure: 'ปฏิเสธการถอนเงิน', //提现失败
    BrandMerchant: 'แบรนด์ร้านค้า', //品牌商家
    WaitingClaimed: 'ยังไม่มีผู้ใช้กดรับ', //待领取
    baht: 'บาท', //铢
    baht1: 'บาท สามารถใช้ได้', //铢，可使用
    ImportCertificateName: 'ชื่อตั๋วแลก', //导入兑换券名称
    InventoryQuantity: 'จำนวนคงคลัง', //库存数量
    HaveImported: 'ดึงข้อมูลแล้ว', //已导入
    a: 'คน', //个
    code: 'รหัสคูปอง', //券码
    IssueStatus: 'สถานะ', //发放状态
    CertificateValidityPeriod: 'วันหมดอายุ', //兑换券有效期
    ImportCode: 'ดึงข้อมูลรหัสคูปอง', //导入券码
    CouponStatus: 'สถานะคูปอง', //优惠券状态
    RedeemPrizeVouchers: 'แลกของรางวัล/คูปอง', //兑换奖品/券
    ExchangeType: 'ประเภทตั๋วแลก', //兑换类型
    NameExchange: 'ชื่อสินค้า', //兑换品名称
    shop: 'ร้านค้า', //商家
    PicExchange: 'ภาพหลักรางวัล', //兑换品主图
    PrizeValue: 'มูลค่ารางวัล', //奖品价值
    PurchasePrice: 'ราคาซื้อ', //采购价
    RedeemPullNewValue: 'แลกคะแนนชวนเพื่อน', //兑换拉新用户值
    PerPersonLimit: 'จำกัดการแลกคนละ', //每人限兑
    ExchangeSpecification: 'คำอธิบายกฎการแลก', //兑换细则描述
    CopyThe: 'ใบ', //份
    PositiveMaximumValue9999: 'กรอกได้เฉพาะตัวเลขจำนวนเต็มเท่านั้น ไม่เกิน 9999', //只能填写正整数，不超过9999
    AddEdit: 'เพิ่ม/แก้ไข', //添加/编辑
    ExchangeCodeManagement: 'จัดการรหัสตั๋วแลก', //兑换券券码管理
    CreationTime: 'เวลาสร้าง', //创建时间
    AfterPurchaseVoucher: 'เมื่อซื้อตั๋วแลกสำหรับใช้ที่หน้าร้านค้าแล้ว นำโค้ดมาใส่ในแบบฟอร์มนี้ หลังจากMXWINNERแลกสำเร็จระบบจะแจกรหัสตั๋วแลกแบบสุ่มตามกฎระเบียบ', //可到店消费的兑换券购买成功后，通过此模块导入，达人兑换成功后，系统根据规则随机发送券码
    NameCoupon: 'ชื่อตั๋วแลก', //兑换券名称
    VoucherBillNumber: 'เลขที่การนำเข้ารหัสตั๋วแลก', //兑换券券码导入单号
    AddRedemptionCouponCode: 'เพิ่มรหัสตั๋วแลก', //添加兑换券券码
    CouponCodeStart: 'เวลาเริ่ม', //兑换券起始时间
    TimeVoucher: 'เวลาสิ้นสุด', //兑换券结束时间
    DerivedCode: 'ส่งออกรหัสตั๋วแลก', //导出券码
    AddPrizesVouchers: 'เพิ่มรางวัล/คูปอง', //添加兑换奖品/券
    ShelfTime: 'เวลาแสดง', //上架时间
    NameExchange: 'ชื่อสินค้า', //兑换品名称
    validityPeriodCoupon: 'วันหมดอายุ', //兑换券有效期限
    PullUserValue: 'รางวัลชวนเพื่อน', //拉新用户值
    ConversionStartTime: 'เวลาเริ่ม', //兑换开始时间
    ConversionEndTime: 'เวลาสิ้นสุด', //兑换结束时间
    ExchangeStatus: 'สถานะสินค้าแลก', //兑换品状态
    GiftExchangeManagement: 'จัดการรางวัลการแลก', //兑换礼品管理
    ReleasePrizesExchange: 'โพสต์รางวัลและตั๋วแลกที่MXWINNERรับ เมื่อโพสต์สำเร็จ MXWINNERจึงจะสามารถแลกของรางวัลและตั๋วแลกในแอปพลิเคชันได้', //发布达人领取的实物奖品和兑换券，发布成功后，达人在APP才能兑换相应奖品及兑换券
    replenishment: 'เติมสต็อก', //补货
    delist: 'เอาลง', //下架
    QuantityPaid: 'จำนวนที่แลก', //已兑数量
    AllConverters: 'สินค้าแลกทั้งหมด', //所有兑换品
    fillDeliveryAddress: 'รอกรอกที่อยู่ผู้รับ', //待填写收货地址
    received: 'ได้รับแล้ว', //已收货
    ExchangeOrderNumber: 'เลขที่การแลก', //兑换单号
    ExchangeInformation: 'ข้อมูลแลกของ', //兑换品信息
    ConversionQuantity: 'จำนวนที่แลก', //兑换数量
    TotalInventory: 'คลังทั้งหมด', //总库存
    ConvertedAmount: 'จำนวนที่แลกไปแล้ว', //已兑换数
    ConversionTime: 'เวลาแลก', //兑换时间
    PrizeStatus: 'สถานะรางวัล', //奖品状态
    TalentAccount: 'เลขบัญชีMXWINNER', //达人账号
    ReceivingPhoneNumber: 'เบอร์โทรผู้รับ', //收货手机号
    addressProvinceCityDistrict: 'ที่อยู่ผู้รับ: เขต/ตำบล แขวง/อำเภอ จังหวัด', //收货地址：省-市-区
    MarkedDelivery: 'จัดส่งสินค้า', //标记发货
    ModifyShipAddress: 'แก้ไขที่อยู่ผู้รับ', //修改收货地址
    Guan: 'ด่านที่', // 关
    Guan1: 'ด่านที่1',
    Guan2: 'ด่านที่2',

    //  7-10
    tipsCreateBrandSelfStore: 'กรุณากรอกข้อมูลให้ถูกต้อง ตรวจสอบเสร็จสิ้นภายใน 3 วันทำการ', //请正确填写相关信息，我们将在3个工作日内完成审核
    confirm: 'ยืนยัน', //确定
    concel: 'ยกเลิก', //取消
    ValidUntil: 'ใช้ได้ถึง', //有效期限至
    actualAmountReceived: 'ยอดเงินที่จะได้รับ', //实际打款到账金额
    DetailsCurrentAccountFunds: 'รายละเอียดยอดเงินในบัญชีขณะนี้', //当前账户资金详情
    ConfirmPayment: 'ยืนยัน', //确认付款
    rejectPayment: 'ปฏิเสธ', //拒绝付款
    PleaseEnterFeedback: 'กรุณากรอกความคิดเห็น', //请输入反馈信息
    AdditiveLogisticsCompany: 'เพิ่มบริษัทขนส่ง', //添加物流公司
    Claimed: 'หมดแล้ว', //已领完
    CashCoupon: 'บัตรกำนัล', //代金券
    PlatformCoupon: 'คูปองแพลตฟอร์ม', //平台优惠券

    expired: 'หมดอายุแล้ว', //已过期
    cancelled: 'ปิดการใช้งานแล้ว', //已作废
    PhysicalPrize: 'ของรางวัล', //实物奖品
    certificate: 'ตั๋วแลก', //兑换券
    WaitingUsed: 'กำลังใช้งาน', //待使用
    invitationCode1: 'เพิ่มรหัสเชิญ', //添加邀请码
    InvitationCodeType: 'ประเภทรหัสเชิญ', //邀请码类型
    InvitationCodeName: 'ชื่อรหัสเชิญ', //邀请码名称
    InvitationCode: 'รหัสเชิญ', //邀请码
    QuantityIssued: 'จำนวน', //发放数量
    DailyLimit: 'จำกัดจำนวนรับได้ต่อวัน', //每天限兑
    maxLimit60: 'สูงสุดไม่เกิน 60 ตัวอักษร', //最多不超过60字符
    number4: 'ตัวเลข ใส่ได้เพียง 4 ตัวเท่านั้น', //数字，只能填写4位数字
    choseTime: 'เลือกวันที่และเวลา', //选择日期时间
    RedEnvelope: 'ฝ่าด่านพิชิตอั่งเปา', //红包闯关
    OpenBeta: 'ช่วงเปิดทดสอบ', //公测
    FollowTime: 'เวลา', //跟进时间
    BrandLocation: 'สถานที่ตั้งแบรนด์', //品牌所属地
    FollowPeople: 'ผู้รับผิดชอบ', //跟进人
    WhetherFollow: 'ติดตามแบรนด์', //是否跟进
    ContactName: 'ชื่อผู้ติดต่อ', //联系人名称
    ContactNumber: 'เบอร์โทรศัพท์', //联系人电话
    BrandOfficialWebsite: 'เว็บไซต์แบรนด์', //品牌官网
    follow: 'ติดตามความคืบหน้า', //跟进
    // 7-11
    PleaseRequiredFieldsCarefully: 'กรุณากรอกให้ถูกต้อง', //请认真填写必填项
    sort: 'ประเภท', //分类
    SupplyChainAlliance: 'ซัพพลายเออร์', //供应链联盟
    BrandSelfSupport: 'แบรนด์ดำเนินการด้วยตนเอง', //品牌自营
    skuCode1: 'เลขSKU', //SKU编号
    skuStock: 'คลังSKU', //SKU库存
    CurrentStock: 'คลังสินค้าขณะนี้', //当前库存
    DeleteOrder: 'ลบคำสั่งซื้อ', //删除订单
    signed: 'ลงชื่อรับสินค้าแล้ว', //已签收
    PayInstallments: 'ผ่อนชำระ', //分期付
    nonPayment: 'ยังไม่ชำระ', //未支付
    BankcardPayment: 'ชำระผ่านบัตรธนาคาร', //银行卡支付
    ThirdPayment: 'ชำระผ่านบุคคลที่สาม', //第三方支付
    Balancepayment: 'ชำระผ่านMXCOME', //余额付
    UploadVideo: 'อัปโหลดวีดิโอ', //上传视频
    ScreeningCondition: 'เกณฑ์การกรอง', //筛选条件
    ServiceOrderNumber: 'หมายเลขบริการ', //服务单号
    ApplicationStatus: 'สถานะคำขอ', //申请状态
    ProcessingTime: 'เวลา', //处理时间
    ProcessingState: 'สถานะการจัดการ', //处理状态
    operator: 'ผู้ดำเนินการ', //操作人员
    // 7 -12
    OrdinaryTask: 'ภารกิจทั่วไป', //普通任务
    activeTask: 'ภารกิจกิจกรรม', //活动任务
    BasicInformation: 'ข้อมูลพื้นฐาน', //基本信息
    SalesAllocation: 'ข้อมูลประกอบการขาย', //销售配置
    ServiceConfiguration: 'ข้อมูลประกอบการบริการ', //服务配置
    Search: 'ค้นหา', //搜索
    completedAdd: 'เพิ่มสำเร็จ', //完成添加
    RefreshingSkuList: 'เมื่อรีเฟรชตารางจะทำให้ข้อมูลเดิมหายไป ต้องการรีเฟรชหรือไม่ ', //刷新列表将导致sku信息重新生成，是否要刷新
    product: 'สินค้า', //商品
    productTime: 'เวลาภารกิจ', //任务时间
    inputPlacer: 'ป้อน', //输入
    priceMoney: 'ราคา', //价格
    day: 'วัน', //天
    activeSecondTip: 'หัวข้อย่อยกิจกรรม', //活动副标题
    RankingReward: 'รางวัลอันดับ', //排名奖励
    SelectedRankRewards: 'รางวัลอันดับที่เลือกแล้ว', //已选择的排名奖励
    SelectRankRewardItems: 'เลือกสินค้ารางวัลอันดับ', //选择排名奖励商品
    ensureNormalDisplay: 'เพื่อให้แสดงผลเป็นปกติ แนะนำให้ใช้ขนาด', //为确保正常显示，建议列表尺寸为
    PleaseSuccessUploaded: 'กรุณารอจนกว่าทุกรูปจะอัปโหลดสำเร็จ หรือ หากเกิดปัญหาเกี่ยวกับอินเทอร์เน็ต กรุณารีเฟรชหน้าเว็บไซต์และอัปโหลดใหม่อีกครั้ง', //请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！
    zhang1: '1ใบ', //1张
    zhang2: '2ใบ', //2张
    zhang3: '3ใบ', //3张
    zhang4: '4ใบ', //4张
    zhang5: '5ใบ', //5张
    zhang6: '6ใบ', //6张
    zhang7: '7ใบ', //7张
    zhang8: '8ใบ', //8张
    zhang9: '9ใบ', //9张
    zhang10: '10ใบ', //10张
    NotSubmitted: 'ยังไม่ส่ง', //未提交
    selfSupport: 'ดำเนินกิจการด้วยตนเอง', //自营
    article: 'รายการ', //条
    KillOrder: 'คำสั่งซื้อFlash sale', //秒杀订单
    Guan3: 'ด่านที่3',

    // 7-17
    PleaseEnterNameImportCoupon: 'กรุณาใส่ชื่อตั๋วแลกที่ต้องการนำเข้า', //请输入导入兑换券名称
    FillNameMerchantOffersExchangeItem: 'กรอกชื่อร้านค้าที่เป็นผู้เสนอสินค้าสำหรับแลก', //填写提供兑换商品的商家名称
    AfterSalePendReview: 'รอตรวจสอบ', //售后待审核
    AfterSaleReceiving: 'รับสินค้า', //售后收货
    SubjectRefundAfterSale: 'รอคืนเงิน', //售后待退款
    AfterSaleClosing: 'ปิดบริการหลังการขาย', //售后关闭
    examine: 'ตรวจสอบ', //审核
    Declined: 'ถูกปฏิเสธ', //已拒绝
    paid: 'ชำระแล้ว', //已付款
    createNow: 'สร้างทันที', //立即创建
    RechargeAccountBalance: 'ยอดเงินที่ให้บัญชีผู้เข้าร่วมทดสอบ', //给公测用户账户余额充值
    InvitationCodeDuration: 'ระยะเวลารหัสเชิญ', //邀请码期限
    InvitationCodeStatus: 'สถานะรหัสเชิญ', //邀请码状态
    noFollowUp: 'ยังไม่มีการติดตาม', //未跟进
    HaveFollowed: 'ติดตามแล้ว', //已跟进
    EventRewardServiceSetting: 'ตั้งค่าค่าบริการรางวัลกิจกรรม', //活动奖励服务费设置
    MerchantSupplyAmount: 'ราคาส่งของร้านค้า', //商家供货金额的
    RewardRatioSystemDefaults: 'หากเว้นว่างในช่องรางวัลภารกิจทั่วไป ระบบจะตั้งค่าริ่มต้นเป็น', //如果普通任务奖励比例为空，系统默认为
    OrderSetup: 'ตั้งค่าคำสั่งซื้อ', //订单设置
    SystemAutomaticallyCloseOrder: 'นาที เมื่อครบเวลา คำสั่งซื้อที่ยังไม่ชำระเงินจะถูกปิดโดยอัตโนมัติ หากเว้นว่าง ระบบจะตั้งค่าเริ่มต้นเป็น 15 นาที', //分钟内不付款系统将自动关闭订单。如果生效时间为空，系统默认为15分钟
    AfterMakingOrder: 'หลังจากสั่งซื้อ', //下单后
    OrderExpiratTime: 'เวลาที่คำสั่งซื้อหมดอายุ', //订单失效时间
    CouponInformat: 'รายละเอียดคูปอง', //优惠券信息
    TipAfterOpenUserReturns: 'แจ้งให้ทราบ: หากเปิดใช้งาน หลังจากผู้ใช้คืนสินค้าจะได้รับคูปองที่ใช้ไปแล้วคืน หากปิดการใช้งาน คูปองที่ผู้ใช้ใช้ไปแล้วจะไม่ได้กลับคืนมา ระบบจะตั้งค่าเริ่มต้นเป็นสถานะเปิดใช้งาน', //提示：开启后，用户退货后退还已使用的优惠券；关闭后，用户下单使用的优惠券不予退还。系统默认为开启状态
    QuantityPurchasePerItem: 'จำนวนสินค้าที่ซื้อต่อครั้ง', //每个商品单次购买数量
    NotMoreThan: 'ไม่เกิน', //不超过
    SinglePurchaseQuantityEachItemEmptySystemDefaults10: 'หากเว้นว่างในช่องจำนวนสินค้าที่ซื้อต่อครั้ง ระบบจะตั้งค่าเริ่มต้นเป็น 10 ชิ้น', //如果每个商品单次购买数量为空，系统默认为10个
    VoucherUsageRules: 'บัตรกำนัล', //代金券使用规则
    AfterClaiming: 'หลังจากรับแล้ว', //领取后
    ValidDefaultValue3Days: 'วัน ที่สามารถใช้ได้ หากเว้นว่าง ระบบจะตั้งค่าเริ่มต้นเป็น 3 วัน', //天内有效。如果失效时间为空，系统默认为3天
    VoucherUseConditions: 'เงื่อนไขการใช้บัตรกำนัล', //代金券使用条件
    ValueVoucher: 'มูลค่าบัตรกำนัล', //代金券面额
    BahtOrderAmountFull: 'บาท เมื่อสั่งซื้อครบ', //铢， 订单金额满
    BahtOrderAmountFull2: 'บาท สามารถใช้ได้', //铢可用
    AdditionalRule: 'เพิ่มกฎ', //增加规则
    MaximumCanAdded: 'เพิ่มได้สูงสุด 8 รายการ', //最多可添加8个

    // 7-18
    NormalQuestReward: 'รางวัลภารกิจทั่วไป', //普通任务奖励
    ActivityLevelReward: 'รางวัลด่านกิจกรรม', //活动关卡奖励
    activityLevelRewardRatioEmpty: 'หากเว้นว่างในช่องรางวัลด่านกิจกรรม ระบบจะตั้งค่าเริ่มต้นเป็น', //如果活动关卡奖励比例为空，系统默认为
    RankingAwards: 'รางวัลใหญ่จัดอันดับ', //排名大奖奖励
    PrizeRewardRatioEmptySystemDefaults: 'หากเว้นว่างในช่องรางวัลใหญ่จัดอันดับ ระบบจะตั้งค่าเริ่มต้นเป็น', //如果排名大奖奖励比例为空，系统默认为
    WithdrawalFeeSetting: 'ตั้งค่าค่าธรรมเนียมการถอนเงิน', //提现手续费设置
    On: 'เปิด', //开启
    Off: 'ปิด', //关闭
    TipsWithdraw: '(แจ้งให้ทราบ: หากเปิดใช้งาน เมื่อร้านค้าถอนเงินจะหักค่าธรรมเนียม โดยยอดเงินเข้าบัญชีจะคิดเป็น ยอดการถอน-ค่าธรรมเนียม หากปิดใช้งาน เมื่อร้านค้าถอนเงินจะไม่หักค่าธรรมเนียม ระบบจะตั้งค่าค่าเริ่มต้นเป็นสถานะปิดการใช้งาน ในสถานะเปิดการใช้งาน หากเว้นว่างในช่องค่าธรรมเนียม ระบบจะตั้งค่าเริ่มต้นเป็น 3%) ', //（提示：开启后，商家提现时要扣除手续费，到账金额=提现金额-手续费；关闭后，商家提现时不扣除手续费，到账金额=提现金额。系统默认为关闭状态；开启状态，如果提现手续费为空，系统默认手续费为3%）分钟内不付款系统将自动关闭订单。如果生效时间为空，系统默认为15分钟
    UserWithdrawalFee: 'ค่าธรรมเนียมการถอนเงินของผู้ใช้:', //用户提现手续费
    TipsWithdraw2: '(แจ้งให้ทราบ: หากเปิดใช้งาน เมื่อผู้ใช้ถอนเงินจะหักค่าธรรมเนียม โดยยอดเงินเข้าบัญชีจะคิดเป็น ยอดการถอน-ค่าธรรมเนียม หากปิดใช้งาน เมื่อผู้ใช้ถอนเงินจะไม่หักค่าธรรมเนียม ระบบจะตั้งค่าค่าเริ่มต้นเป็นสถานะเปิดการใช้งาน หากเว้นว่างในช่องค่าธรรมเนียม ระบบจะตั้งค่าเริ่มต้นเป็น 3%)', //（提示：开启后，用户提现时要扣除手续费，到账金额=提现金额-手续费；关闭后，用户提现时不扣除手续费，到账金额=提现金额。系统默认为开启状态，如果提现手续费为空，系统默认手续费为3%）
    RedEnvelopeCrossTaskSet: 'ตั้งค่าภารกิจฝ่าด่านพิชิตอั่งเปา', //红包闯关任务设置
    ValidityTorrentUserQualification: 'ระยะเวลาผู้มีคุณสมบัติ', //种子用户资格有效期
    redPackageTips: 'หากเว้นว่างในช่องระยะเวลาผู้มีคุณสมบัติ ระบบจะตั้งค่าเริ่มต้นเป็น 7 วัน คุณสมบัติที่เกินกำหนดจะไม่ได้รับคุณสมบัติในการฝ่าด่านอีกต่อไป', //如果种子用户资格有效期为空，系统默认为7天。逾期资格失效，不再获得闯关资格
    redEntryQualificatValid: 'ระยะเวลาคุณสมบัติฝ่าด่านพิชิตอั่งเปา', //红包闯关资格有效期
    month: 'เดือน', //月
    year: 'ปี', //年
    redPackageTips2: 'หากเว้นว่างในช่องระยะเวลาคุณสมบัติฝ่าด่านพิชิตอั่งเปา ระบบจะตั้งค่าเริ่มต้นเป็น 90 วัน คุณสมบัติที่เกินกำหนดจะไม่ได้รับรางวัลอีกต่อไป', //如果闯关资格有效期为空，系统默认为180天。逾期资格失效，不再获得红包奖励
    RedActivityLevelSettings: 'ตั้งค่าด่านกิจกรรมฝ่าด่านพิชิตอั่งเปา', //红包闯关活动关卡设置
    BonusAmount: 'ยอดเงินโบนัส', //奖励红包金额
    THB: 'บาท', //泰铢
    if: 'ถ้าหาก', //如果
    redAmountEmptySystemDefaults: 'เว้นว่างในช่องยอดเงินโบนัส ระบบจะตั้งค่าเริ่มต้นเป็น', //奖励红包金额为空，系统默认为
    crosredEnvelopeLevelSet: 'ตั้งค่าระดับโบนัสในฝ่าด่านพิชิตอั่งเปา', //红包闯关红包层级设置
    InviteUsersFull: 'เชิญเพื่อนครบ', //邀请新用户满
    redEnvelopeRewardPlatformServiceSingleItem: 'แต่ละรางวัล=ค่าบริการแพลตฟอร์มของสินค้าแต่ละชิ้น', //每个红包奖励=单个商品的平台服务费

    // 7-20
    CashedOut: 'แลกครบแล้ว', //已兑完
    batchAuth: 'ตรวจสอบหลายรายการ', //批量审核
    TaskActivityStatisticsPeriod: 'ระยะเวลาสรุปผลภารกิจ/กิจกรรม:', //任务/活动统计期:
    TaskActivityDue: 'ระยะเวลาการรับรางวัลภารกิจ/กิจกรรม:', //任务/活动逾期:
    TaskActivityStatisticsPeriodEnd: 'หลังจากภารกิจ/กิจกรรมสิ้นสุดลง ใช้เวลาสรุปผล', //任务/活动结束时期后，统计期为
    TaskActivityStatisticsPeriOverdue: 'หลังจากภารกิจ/กิจกรรมสิ้นสุดลง มีเวลาในการรับรางวัล', //任务/活动结束时期后，领奖逾期为
    MissionActivityRewardPeriod7: 'วัน หากเว้นว่างในช่องระยะเวลาสรุปผลภารกิจ/กิจกรรม ระบบจะตั้งค่าเริ่มต้นเป็น 7 วัน', //天，如果任务/活动统计期为空，系统默认为7天
    MissionActivityRewardPeriod8: 'วัน หากเว้นว่างในช่องระยะเวลาการรับรางวัลภารกิจ/กิจกรรม ระบบจะตั้งค่าเริ่มต้นเป็น 8 วัน', //天，如果任务/活动领奖逾期时间为空，系统默认为8天
    awardTimeSet: 'ตั้งค่าเวลาการรับรางวัล' //领奖时间设置
  },

  //  7.26号后添加的提示语
  supplementaryPrompt: {
    pleaseAddOne: 'กรุณาเพิ่มอย่างน้อย 1 ประเภท', //请至少添加一个分类入口！！
    pleaseAddLast: 'กรุณากรอกข้อมูลด้านบนให้ครบถ้วนก่อน', //请先填写完上个分类入口
    pleaseAddLevelNotNull: 'ไม่สามารถเว้นว่างในช่องนี้ได้ กรุณากรอกข้อมูล', //分类不能为空，请认真填写分类!
    ClassificationNotRepeated: 'ประเภทไม่สามารถซ้ำกันได้', //分类不能重复！
    PleaseEnterFullAddress: 'กรุณากรอกข้อมูลที่อยู่', //请输入详细地址
    PleaseSelectRegion: 'กรุณาเลือกพื้นที่', //请选择所在地区
    PleaseEnterPostalCode: 'กรุณากรอกรหัสไปรษณีย์', //请输入邮编
    PleaseEnterAdministratorName: 'กรุณากรอกชื่อผู้ดูแล', //请输入管理人名称
    PleaseEnterContactNumber: 'กรุณากรอกเบอร์โทรศัพท์', //请输入联系电话
    PleaseEnterWarehouseName: 'กรุณากรอกชื่อคลังสินค้า', //请输入仓库名称
    VideoUploadedSuccessfully: 'อัปโหลดวิดีโอสำเร็จ!', //视频上传成功！
    PleaseSelectOperationType: 'กรุณาเลือกประเภทการจัดการ', //请选择操作类型
    PleaseSelectProductWantOperate: 'กรุณาเลือกสินค้าที่ต้องการจัดการ', //请选择要操作的商品
    WhetherPerformBatchOperation: 'ต้องการจัดการหลายรายการใช่หรือไม่', //是否要进行该批量操作?
    WhetherModifyIt: 'ต้องการจัดการใช่หรือไม่', //是否要进行修改?
    SkuInformationAvailable: 'ไม่มีข้อมูลsku', //暂无sku信息
    ModifiedSuccessfully: 'แก้ไขสำเร็จ!', //修改成功！
    OrderShipSuccessfully: 'จัดส่งสำเร็จ!', //订单发货成功！
    PleaseChecKItemsAssignPackages: 'กรุณาเลือกสินค้าที่ต้องการแบ่งกล่องพัสดุ', //请勾选需要分配包裹的商品!
    WarmReminder: 'คำแนะนำ', //温馨提示
    ValidityPeriod: 'เอกสารของคุณกำลังจะหมดอายุ ไม่สามารถผูกบัญชีกับบัตรธนาคารได้ แนะนำให้ยื่นขอเอกสารใหม่มาเปลี่ยนหรือใช้บัตรธนาคารอื่น เพื่อผูกบัญชีสำหรับดำเนินการถอนเงิน', //您的证件有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！
    ValidityPeriod1: 'บัตรธนาคารของคุณกำลังจะหมดอายุ ไม่สามารถผูกบัญชีกับบัตรธนาคารได้ แนะนำให้ยื่นขอเอกสารใหม่มาเปลี่ยนหรือใช้บัตรธนาคารอื่น เพื่อผูกบัญชีสำหรับดำเนินการถอนเงิน', //您的银行卡有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！
    PleaseSelectBankCard: 'กรุณาเลือกบัตรธนาคาร', //请选择银行卡！！
    WithdrawalSubmitSuccessfully: 'ยื่นคำขอถอนเงินสำเร็จ!', //提现申请提交成功！
    BankCardBindSuccessful: 'ผูกบัตรธนาคารสำเร็จ!', //银行卡绑定成功！
    PleaseFillBankName: 'กรุณากรอกชื่อธนาคาร', //请填写银行名称
    PleaseFillCardHolderName: 'กรุณากรอกชื่อผู้ถือบัตร', //请填写持卡人姓名
    PleaseFillName: 'กรุณากรอกชื่อ-สกุล', //请填写姓名
    BankAccount25Digits: 'เลขบัญชีธนาคารต้องไม่เกิน 25 หลัก', //银行账号需小于25位数！
    PleaseFillBankAccountNumberOnly: 'กรุณากรอกเลขบัญชีธนาคารเป็นตัวเลขเท่านั้น!', //请填写银行账号且只能为数字！
    PleaseOnlyNumbers: 'กรุณากรอกเลขบัญชีธนาคารเป็นตัวเลขเท่านั้น!', //请填写银行账号且只能为数字！
    your: '', //您的
    validityPeriodAboutExpire: 'กำลังจะหมดอายุ ไม่สามารถผูกบัญชีกับบัตรธนาคารได้ แนะนำให้ยื่นขอเอกสารใหม่มาเปลี่ยนหรือใช้บัตรธนาคารอื่น เพื่อผูกบัญชีสำหรับดำเนินการถอนเงิน', //有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！
    CancelCouponWillCancelled: 'ปิดการใช้งานคูปอง คูปองที่ยังไม่กดรับจะถูกปิดการใช้งาน และจะไม่สามารถรับต่อไปได้ ยืนยันปิดการใช้งานหรือไม่', //作废优惠券，未领取的优惠券会作废，不能继续领取，是否作废？
    SuccessfulCancellation: 'ปิดการใช้งานคูปองสำเร็จ!', //成功作废！
    PleaseSelectContentFirstBatchOperation: 'กรุณาเลือกเนื้อหาที่ต้องการ จึงจะสามารถจัดการหลายรายการได้!', //请先选中内容，再做批量操作！
    CancelCouponsBatches: 'ปิดการใช้งานคูปองหลายใบ คูปองที่ยังไม่กดรับจะถูกปิดการใช้งาน และจะไม่สามารถรับต่อไปได้ ยืนยันปิดการใช้งานทั้งหมดหรือไม่', //批量作废优惠券，未领取的优惠券会作废，不能继续领取，是否批量作废？
    editSuccess: 'แก้ไขสำเร็จ!', //编辑成功！
    GoodsEditSuccessfully: 'แก้ไขสินค้าสำเร็จ!', //修改商品成功！
    CouponValidityPeriod: 'วันหมดอายุคูปอง', //优惠券有效期
    PleaseEnterTotalAmountIssued: 'กรุณาใส่จำนวนคูปอง', //请输入发放总量
    PleaseCouponValidityPeriod: 'กรุณากรอกวันหมดอายุคูปอง', //请输入优惠券有效期
    EnabledSuccessfully: 'เปิดใช้งานสำเร็จ!', //启用成功！
    InvalidDataEnabledSuccessfully: 'เปิดใช้งานคูปองที่ปิดการใช้งานไว้สำเร็จแล้ว! เมื่อเปิดใช้งานคูปองหากคูปองหมดอายุจะต้องแก้ไขวันหมดอายุก่อน จึงจะสามารถเปิดใช้งานได้', //已作废的数据启用成功！已过期的数据启用时，需要更新优惠券的有效期限后，才能启用！
    DoDelCouponsBulk: 'ต้องการลบคูปองทั้งหมดที่เลือกใช่หรือไม่', //是否批量删除优惠券？

    //  7-28
    processed: 'รอดำเนินการ', //待处理
    ReturningGoods: 'อยู่ระหว่างคืนสินค้า', //退货中
    GiveawayStockSmallerAvailableStock: 'จำนวนสินค้าในคลังของรางวัลจะต้องน้อยกว่าจำนวนสินค้าคงคลัง', //赠品库存要小于可用库存！
    PleaseFillGiftInventory: 'กรุณาใส่คลังของรางวัล', //请填写赠品库存！
    endDateGreaterStartDate: 'วันที่สิ้นสุดจะต้องช้ากว่าวันที่เริ่ม', //结束日期要大于开始日期！
    endDate7OlderStartDate: 'วันที่สิ้นสุดจะต้องช้ากว่าวันที่เริ่มไม่เกิน 7 วัน', //结束日期不能大于开始日期超过7天！
    PleaseSelectProduct: 'กรุณาเลือกสินค้า', //请选择商品！
    PleaseFillInventory: 'กรุณาใส่คลังสินค้า', //请填写商品库存！
    taskInventorySmallerAvailableInventory: 'จำนวนสินค้าในคลังภารกิจจะต้องน้อยกว่าจำนวนสินค้าคงคลัง', //任务库存要小于可用库存！
    ActivityAudit: 'ตรวจสอบกิจกรรม', //活动审核
    ConvertibilityPeriod: 'จำกัดระยะเวลาที่สามารถแลกได้', //可兑换期限
    PleaseEnterExchangeVoucher: 'กรุณากรอกชื่อของแลก/ตั๋วแลก', //请输入兑换品/兑换券名称
    PleaseEnterMerchant: 'กรุณากรอกร้านค้า', //请输入商家
    PleaseUploadExchangeCouponMasterChart: 'กรุณาอัปโหลดภาพหลักของแลก/ตั๋วแลก', //请上传兑换品/兑换券主图
    PleaseEnterPrizeVoucher: 'กรุณากรอกมูลค่าของรางวัล/ตั๋วแลก', //请输入奖品/兑换券价值
    PleaseEnterPurchasePrice: 'กรุณากรอกราคาซื้อ', //请输入采购价
    PleaseSelectCoupon: 'กรุณาเลือกตั๋วแลก', //请选择兑换券
    PleaseEnterNewUserValueRedemption: 'กรุณากรอกจำนวนการแลกรางวัลชวนเพื่อน', //请输入兑换拉新用户值
    PleaseEnterInventoryQuantity: 'กรุณากรอกจำนวนการแลกรางวัลชวนเพื่อน', //请输入兑换拉新用户值
    PleaseFillExchangeDescription: 'กรุณาใส่รายละเอียดเงื่อนไขการแลก', //请填写兑换细则描述
    PleaseFillStartDate: 'กรุณาใส่วันที่เริ่ม', //请填写开始日期
    PleaseFillEndDate: 'กรุณาใส่วันที่สิ้นสุด', //请填写结束日期
    PrizeDeliveryManagement: 'จัดการการจัดส่งของรางวัล', //奖品发货管理
    PrizeDeliveryManagementTips: 'ในการจัดการการจัดส่งของรางวัล หลังจากMXWINNERแลกของรางวัลและ/หรือตั๋วแลกแล้วจะส่งไปยังบัญชีของMXWINNERโดยอัตโนมัติ', //奖品发货管理，实物奖品和兑换券奖品在达人兑换后，会自动发放到达人奖品账户中
    ConversionTime: 'เวลาที่แลก', //兑换时间
    ConsigneeArea: 'พื้นที่จัดส่ง', //收货人区域
    ExchangeOrderNumber: 'หมายเลขการแลก', //兑换单号
    remaining: 'เหลืออีก', //还剩
    TimeOut: 'หมดเวลา', //已超时
    SetInventory: 'สต็อกสินค้า', //设定库存
    QueryResult: 'ผลลัพธ์การค้นหา', //查询结果
    ActiveTime: 'ระยะเวลากิจกรรม', //活动时间
    IncentiveStock: 'คลังรางวัล', //奖励库存
    PrizeInventory: 'คลังรางวัลใหญ่', //大奖库存
    AddBankCard: 'เพิ่มบัตรธนาคาร', //添加银行卡
    amountDeductedPlatformCoupon: 'ยอดหักส่วนลดคูปองแพลตฟอร์ม', //平台优惠券抵扣金额
    ReimburseAmountMerchantCoupon: 'ยอดคืนส่วนลดคูปองร้านค้า', //补回商家优惠券抵扣金额
    ConfirmShip: 'ยืนยันและจัดส่ง', //确认并发货
    EditWaybill: 'แก้ไขใบนำส่งสินค้า', //编辑运单
    ConfirmDelivery: 'ยืนยันจัดส่ง', //确认发货
    parcel: 'กล่องพัสดุ', //包裹
    hierarchy: 'ขั้นที่', //层级
    hierarchy1: 'ขั้นที่1', //层级1
    hierarchy2: 'ขั้นที่2', //层级2
    hierarchy3: 'ขั้นที่3', //层级3

    // 8-1
    AddedLevelCategoryEntry1: 'เพิ่มหมวดหลัก', //新增一级分类入口
    PleaseEnterFirstLevelCategoryEntryName: 'กรุณากรอกชื่อหมวดหลัก', //请输入一级分类入口名称
    FirstClassClassificatEntry: 'หมวดหลัก', //一级分类入口
    FirstClassClassificatEntry2: 'หมวดย่อย', //二级分类入口
    FirstClassClassificatEntry2Num: 'จำนวนหมวดย่อย', //二级分类入口数量
    reveal: 'แสดง', //显示
    sort: 'จำนวน', //排序
    NewSecondaryClassificate: 'เพิ่มหมวดย่อย', //新增二级分类
    NewFirstClassificatCommodities: 'เพิ่มหมวดหลักสินค้า', //新增商品一级分类
    PleaseEnterProductCategoryName: 'กรุณากรอกชื่อหมวดหลักสินค้า', //请输入商品一级分类名称
    PrimaryClassificatCommodities: 'สินค้าหมวดหลัก', //商品一级分类
    SecondaryClassificatCommodities: 'สินค้าหมวดย่อย', //商品二级分类
    SubordinateQuantity: 'จำนวนหมวดย่อย', //下级数量
    NewSecondaryClassificatCommodity: 'เพิ่มหมวดย่อยสินค้า', //新增商品二级分类
    EnterFirstClassNameProduct: 'กรอกชื่อหมวดหลักสินค้า', //输入商品一级分类名称
    view: 'ดู', //查看
    ClassificationName: 'ชื่อหมวด', //分类名称
    verify: 'ยืนยัน', //确认
    PayAttentPlatformClassificatRule: 'ปฏิบัติตามระเบียบการจัดหมวดหมู่ของแพลตฟอร์ม', //注意平台分类规则
    UpperCategory: 'หมวดหลัก:', //上级分类：
    EditSpecification: 'แก้ไขรูปแบบ', //编辑规格
    PleaseEnterInvitationCodeName: 'กรุณากรอกชื่อรหัสเชิญ', //请输入邀请码名称
    PleaseSelectInvitaCodeType: 'กรุณาเลือกประเภทรหัสเชิญ', //请选择邀请码类型
    PleaseEnterInvitatCode: 'กรุณากรอกรหัสเชิญ', //请输入邀请码
    OnlyDigitsCanEntered4: 'ใส่ตัวเลข 4 หลักเท่านั้น', //只能填写4位数字
    PleaseEnterPrizeValue: 'กรุณากรอกมูลค่าของรางวัล', //请输入奖品价值
    UpDigits6: 'สูงสุด 6 หลัก', //最多6位数
    PleaseEnterReleaseQuantity: 'กรุณากรอกจำนวน', //请输入发放数量
    PleaseEnterStartDate: 'กรุณากรอกวันและเวลาที่เริ่ม', //请输入开始日期
    PleaseEndDate: 'กรุณากรอกวันและเวลาที่สิ้นสุด', //请输入结束日期
    CreatedSuccessfully: 'สร้างสำเร็จ!', //创建成功！
    lengthLessCharacters60: 'ความยาวไม่เกิน 60 ตัวอักษร', //长度小于60字符
    PleaseSelectCouponValidityPeriod: 'กรุณาระบุวันหมดอายุตั๋วแลก', //请选择兑换券有效期
    RemovedSuccessfully: 'ลบออกสำเร็จ!', //移除成功！
    unissued: 'ยังไม่แจก', //未发放
    WaitingUsed: 'รอใช้งาน', //待使用

    // 8-4
    RedEnvelopeValueThreeLevels: 'เป็นยอดรวม 3 ด่านของอั่งเปา', //红包闯关资格三关总价值
    IndividualShop: 'ร้านค้าบุคคลธรรมดา', //个人店铺
    input: 'ใส่หมายเลข', //输入
    CorrespondingGoods: 'รหัสสินค้า', //对应商品
    BarCode: 'บาร์โค้ด', //条码
    ShippingTime: 'เวลาจัดส่ง', // 发货时间
    ReceiptTime: 'เวลารับสินค้า', // 收货时间

    // 8-7新
    deliveryModeExpressTemplate: 'สำหรับรูปแบบการจัดส่งด่วนทั้งหมดในวิธีการจัดส่ง จำเป็นต้องใส่ข้อมูลการตั้งค่าค่าเริ่มต้นรูปแบบการจัดส่ง', //运送方式下所有快递模板，默认运费模板设置字段必填！
    EditingSuccess: 'แก้ไขสำเร็จ!!', //编辑成功！！
    CreatedSuccessfully: 'สร้างสำเร็จ!', //创建成功！！
    PleaseFillImportCountryCarefully: 'กรุณากรอกประเทศนำเข้า!', //请认真填写进口国家！
    PleaseRegionsOriginCarefully: 'กรุณากรอกข้อมูลที่อยู่สถานที่ผลิต', //请认真填写产地的三级行政区！
    PleaseRefreshPageSelectStoreAgain: 'กรุณารีเฟรชหน้าต่างและเลือกร้านค้าใหม่อีกครั้ง', //请刷新页面重新选择店铺！
    PanningPrice: 'ราคาMXCOME', //淘金价
    PlatformPrice: 'ราคาแพลตฟอร์ม', //平台价格
    PlatformProfit: 'ส่วนแบ่งแพลตฟอร์ม', //平台利润
    TalentProfit: 'ส่วนแบ่ง MXWINNER', //达人利润
    ViewShipTemplateDetails: 'ดูรายละเอียดรูปแบบการจัดส่ง', //查看运费模板详情
    propertyValueCannotEmpty: 'ไม่สามารถเว้นว่างในช่องนี้ได้', //属性值不能为空
    PleaseParametersSpecificaTemplate: 'กรุณากรอกรายละเอียดสินค้าเพิ่มเติม', //请先在规格模板中填写参数！
    PleaseSelectShipTemplate: 'กรุณาเลือกรูปแบบการจัดส่ง', //请选择运费模板！
    specificationTemplateSaleInformat: 'กรุณากรอกข้อมูลลักษณะสินค้าและการขายสินค้าให้ครบถ้วน', //请认真填写规格模板和销售信息！！
    PleaseFillSKUCode: 'กรุณากรอกเลข SKU', //请认真填写SKU编码
    PleaseFilSupplyPrice: 'กรุณากรอกราคาส่ง', //请认真填写供货价
    PleaseFillSuggestedPrice: 'กรุณากรอกราคาแนะนำ', //请认真填写建议售价
    PleaseFillPrice: 'กรุณากรอกราคาMXCOME', //请认真填写淘金价
    goldRushPriceGreaterSupplyPrice: 'ราคาMXCOMEจะต้องสูงกว่าราคาส่ง', //淘金价应大于供货价
    PleaseFillInventory: 'กรุณากรอกคลังสินค้า', //请认真填写商品库存
    PleaseFillProductLength: 'กรุณากรอกความยาว', //请认真填写商品长度
    PleaseFillProductWidth: 'กรุณากรอกความกว้าง', //请认真填写商品宽度
    PleaseFillProductHeight: 'กรุณากรอกความสูง', //请认真填写商品高度
    PleaseFillGrossWeight: 'กรุณากรอกน้ำหนัก', //请认真填写商品毛重
    WhetherAuditProduct: 'ต้องการตรวจสอบสินค้านี้หรือไม่', //是否要审核该产品
    SubmitSuccess: 'ส่งสำเร็จ', //提交成功
    WhetherSubmitProduct: 'ต้องการส่งสินค้านี้หรือไม่', //是否要提交该产品
    FillNameMerchantOffers: 'กรอกชื่อร้านค้าที่เป็นผู้เสนอสินค้าแลก', //填写提供兑换商品的商家名称
    ExchangeLOGO: 'โลโก้สินค้าแลก', //兑换品LOGO
    MasterChartRedemptionNotes: 'ภาพหลักตั๋วแลก', //兑换券主图
    Maximum1Photo1M: 'อัปโหลดได้สูงสุด 1 รูป รองรับไฟล์ .jpgและ.png แต่ละรูปขนาดไม่เกิน 3MB', //最多1张，照片支持格式jpg，png，每张不超过1M
    Maximum4Photo1M: 'อัปโหลดได้สูงสุด 4 รูป รองรับไฟล์ .jpgและ.png แต่ละรูปขนาดไม่เกิน 3MB', //最多4张，照片支持格式jpg，png，每张不超过1M
    AddSuccessful: 'เพิ่มสำเร็จ', //添加成功
    PleaseSelectProductFirst: 'กรุณาเลือกสินค้าก่อน', //请先选择商品
    CancelUnclaimedCouponWhetherCancel: 'เมื่อปิดการใช้งานคูปอง คูปองที่ยังไม่กดรับจะถูกปิดการใช้งาน และจะไม่สามารถรับต่อไปได้ ยืนยันปิดการใช้งานหรือไม่', //作废优惠券，未领取的优惠券会作废，不能继续领取，是否作废
    CodeTypeOpenTestPrizeMandatory: 'หากรหัสเชิญเป็นประเภททดสอบสาธารณะ จำเป็นต้องกรอกมูลค่ารางวัลด้วย', //邀请码类型为公测时，奖品价值为必填项！！
    DailyLimitGreaterThanAmountIssued: 'การจำกัดการแลกไม่สามารถมากกว่าจำนวนทั้งหมด', //每天限兑不能大于发放总量！
    PleaseEnterNumber: 'กรุณากรอกตัวเลข', //请输入数字！！
    withdrawalAmountWithdrawalAmount: 'ยอดการถอนเงินไม่สามารถเกินยอดที่สามารถถอนได้', //提现金额不能超过可提现金额！！
    withdrawalAmountCannotbe0: 'ยอดการถอนเงิน ไม่สามารถเป็น 0', //提现金额不能为0！

    // 8-9
    withdrawalAmountCannotbe0: 'ยอดการถอนไม่สามารถเป็น 0 ได้', //提现金额不能为0！
    PleaseEnterAdministratorName: 'กรุณากรอกชื่อผู้ดูแล', //请输入管理人名称
    PleaseEnterLogisticsCompanyName: 'กรุณากรอกชื่อบริษัทขนส่ง', //请输入物流公司名称
    NoMoreThan3Packages: 'กล่องพัสดุไม่เกิน 3 กล่อง', //包裹不能超过3个
    ShippingWaybillNumberEmpty: 'ไม่สามารถเว้นว่างในช่องหมายเลขใบกำกับสินค้า', //发货运单号不能为空！！
    DeleteItPleaseExerciseCaution: 'ยืนยันลบหรือไม่ กรุณาตรวจสอบความถูกต้อง', //确定要删除吗？请谨慎操作！
    SuccessfullyDelete: 'ลบแล้ว', //成功删除!
    PleaseFillOrderHowManyBahtUsed: 'กรุณาระบุจำนวนเงินที่ต้องสั่งซื้อครบจึงจะสามารถใช้ได้', //请填写订单满多少铢可使用！
    AddCouponSuccessfully: 'เพิ่มคูปองสำเร็จ', //添加优惠券成功！！
    ImportSuccessfully: 'นำเข้าสำเร็จ', //导入成功
    inventoryNotbe0: 'ไม่สามารถเว้นว่างในช่องจำนวนคงคลัง', //库存数量不能为0！
    PleaseSelectActiveArea: 'กรุณาเลือกพื้นที่จัดกิจกรรม', //请选择活动区域
    SelectCoupon: 'เลือกตั๋วแลก', //选择兑换券
    CouponLOGO: 'โลโก้ตั๋วแลก', //兑换券LOGO
    couponcodeGroupAddedCouponCodeManagement: 'เลือกรหัสตั๋วแลกที่เพิ่มในเมนู "จัดการรหัสตั๋วแลก"', //选择【兑换券券码管理】中添加的兑换券券码组
    valueVoucher: 'มูลค่าตั๋วแลก', //兑换券价值
    PleaseEnterInteger: 'กรุณากรอกจำนวนเต็ม', //请输入整数!
    No4MainImages: 'ภาพหลักต้องไม่เกิน 4 รูป', //主图不能超过4张!
    SaveSuccessfully: 'บันทึกสำเร็จ', //保存成功!
    CurrentDeliveryAddress: 'ที่อยู่จัดส่งขณะนี้', //当前收货地址
    ExchangeGoodsReplenishment: 'เติมสต็อกของแลก', //兑换品补货
    ConfirmRedeemPrizeShelf: 'ยืนยันแสดงของแลกดังกล่าว', //确定将此兑换奖品上架
    stockPleaseRestockContinuShelves: 'คลังคงเหลือไม่เพียงพอ กรุณาเติมสินค้าในสต็อกก่อนจึงจะสามารถแสดงบนแอปพลิเคชันได้', //库存不足，请先补货再继续上架！
    SuccessShelves: 'แสดงบนแอปพลิเคชันแล้ว!', //上架成功！
    ConfirmRedemptionPrizeOffShelf: 'ยืนยันนำของแลกดังกล่าวออก', //确定将此兑换奖品下架
    RemovedSuccessful: 'นำสินค้าออกจากแอปพลิเคชันแล้ว!', //下架成功!
    ReplenishmentSuccess: 'เติมสต็อกสำเร็จ!', //补货成功!
    ConfirmDelivery: 'ยืนยันจัดส่งสินค้า', //确定发货!
    TrackingNumber: 'หมายเลขติดตามพัสดุ', //快递单号!
    PleaseFillLogisticsCompanyName: 'กรุณากรอกชื่อบริษัทขนส่ง', //请填写物流公司名称!
    deleteConverterWhetherBatchDelete: 'เลือกลบของแลกหลายรายการ ต้องการลบรายการที่เลือกทั้งหมดหรือไม่', //批量删除兑换品，是否批量删除!
    BatchDeletionSucceeded: 'ลบรายการที่เลือกทั้งหมดแล้ว', //批量删除成功!
    DeliverySuccess: 'จัดส่งสำเร็จ!', //发货成功!
    PhysicalPrizeInformat: 'ข้อมูลของแลก', //实物奖品信息!
    value: 'มูลค่า', //价值
    expire: 'หมดอายุ', //到期
    HaveAlreadyBeen: '', //已在
    DeliverGoods: 'จัดส่ง', //发货
    ReceiveGoods: 'รับสินค้า', //收货
    validity: 'วันหมดอายุ', //有效期
    TotalConsumptionUserValues: 'ยอดหักคะแนนชวนเพื่อนทั้งหมด', //共消耗拉新用户值
    full: 'ครบ', // '满'
    available: 'สามารถใช้ได้', //'可用'
    // 8-14
    PartialGoods: 'สินค้าบางส่วน', //部分商品
    AllGoods: 'สินค้าทั้งหมด', //全部商品
    TobeListed: 'รอแสดงบนแอปพลิเคชัน', //待上架
    AlreadyListed: 'แสดงบนแอปพลิเคชันแล้ว', //已上架
    NoLongerAvailable: 'ไม่แสดงบนแอปพลิเคชัน', //已下架
    RealNameAudit: 'ตรวจสอบการยืนยันตัวตน', //实名审核
    PleaseConfirmAuthenticationUserMatchesIDInformation: 'กรุณายืนยันข้อมูลการยืนยันตัวตนและเอกสารที่เกี่ยวข้อง', //请确认实名认证用户信息与证件信息匹配
    UserData: 'ข้อมูลผู้ใช้', //用户资料
    RealName: 'ชื่อ-สกุล', //真实姓名
    RegisteredMobilePhone: 'เบอร์โทรศัพท์ที่ลงทะเบียน', //注册手机
    // 8-17
    // ChangeProductHasCreatedTask: 'สินค้านี้อยู่ในภารกิจ ไม่สามารถแก้ไขได้ขณะดำเนินการภารกิจ', //该商品已经创建了任务，任务有效期保持一致，不需要再手动设置
    ChangeProductHasCreatedTask: "เมื่อสร้างภารกิจ ระยะเวลาภารกิจจะตรงกับวันที่ตั้งค่าไว้ ไม่สามารถแก้ไขเวลาภารกิจได้", //该商品已经创建了任务,任务有效期保持一致,不需要再手动设置

    ConfirmTemplateDeletion: 'ยืนยันลบรูปแบบ', //确认删除模板？
    CopyTemplateSuccessful: 'คัดลอกรูปแบบสำเร็จ', //复制模板成功！！
    wholeCountry: 'ทั่วประเทศ', //全国
    ExceptDesignatedAreas: 'นอกเหนือจากพื้นที่ที่กำหนดไว้ ค่าส่งในพื้นที่อื่นๆ จะใช้ค่าตาม "ค่าเริ่มต้น"', //除指定地区外，其余地区的运费采用“默认运费”
    DefaultTemplate: 'ค่าเริ่มต้น', //默认模板
    CancelBatch: 'ยกเลิกหลายรายการ', //取消批量
    FreePostageBaht: 'บาท ส่งฟรี', //铢包邮
    // 8-18
    // StoreAudit: 'ตรวจสอบร้านค้า', //店铺审核
    // ShopInformation: 'ข้อมูลร้านค้า', //店铺信息
    // PleaseStoreBrandBusinessInformation: 'กรุณาตรวจสอบแบรนด์ร้านค้าและข้อมูลกิจการให้ถูกต้อง', //请确认店铺品牌及经营信息
    // BrandInformation: 'ข้อมูลแบรนด์', //品牌信息
    // LevelReward: 'รางวัลด่าน', //关卡奖励
    // 8-21
    GrowthMissionsOnlySelect3SPUs: 'เครื่องมือการเติบโตของภารกิจทั่วไปเลือกได้สูงสุด 3 รหัสกลุ่มสินค้า (SPU)!!', //普通任务的增长工具最多只能选择3个spu！！
    QuestOnly3SpuItemsPerLevel: 'สินค้าภารกิจในแต่ละด่านเพิ่มได้เพียง 1-3 รหัสกลุ่มสินค้า (SPU)!!', //任务商品每关只能有1-3个spu商品！！
    RankingRewardsUpTo5SKUs: 'เพิ่มรางวัลอันดับสูงสุด 5 รหัสสินค้า (SKU)!!', //排名奖励最多5个sku！！
    ActivityLevelRewardsUpTo3SPUs: 'เพิ่มรางวัลด่านสูงสุด 3 รหัสกลุ่มสินค้า (SPU)!!', //活动关卡奖励最多3个spu！！
    NormalQuestItemsOnlyAddOneSpu: 'สินค้าในภารกิจทั่วไปเพิ่มได้สูงสุดเพียง 1 รหัสกลุ่มสินค้า (SPU)!', //普通任务商品最多只能添加一个spu！
    AddUser: 'เพิ่มผู้ใช้', //添加用户
    Type: 'ประเภท:', //类型：
    AccountNumber: 'ไอดี:', //账号：
    AccountNumber1: 'ไอดี', //账号
    Name: 'ชื่อ-สกุล:', //姓名：
    Name1: 'ชื่อ-สกุล', //姓名
    email: 'อีเมล:', //邮箱：
    password: 'รหัสผ่าน:', //密码：
    remark: 'หมายเหตุ:', //备注：
    WhetherEnable: 'เปิดใช้งานหรือไม่', //是否启用
    merchant: 'ร้านค้า', //商家
    Administrator: 'แอดมิน', //管理员
    AddTime: 'เวลาที่สร้าง', //添加时间
    LastLogin: 'เข้าใช้งานล่าสุด', //最后登录
    AssignRoles: 'แบ่งหน้าที่', //分配角色
    yes: 'ใช่', //是
    no: 'ไม่', //否
    PleaseFillAccountNumber: 'กรุณากรอกไอดี', //请填写帐号
    PleaseFillAccountName: 'กรุณากรอกชื่อ-สกุล', //请填写姓名
    PleaseFillAccountEmail: 'กรุณากรอกอีเมล', //请填写邮箱
    PleaseFillAccountPassword: 'กรุณากรอกรหัสผ่าน', //请填写密码
    searchView: 'ค้นหา', //查询搜索
    RoleName: 'ชื่อเรียกบทบาท', //角色名称
    Description: 'คำอธิบาย', //描述
    UserNumber: 'จำนวนผู้ใช้', //用户数
    AllocateResources: 'จัดสรรทรัพยากร', //分配资源
    DistributionMenu: 'แจกจ่ายเมนู', //分配菜单
    WhetherSubmitData: 'ต้องการส่งข้อมูลหรือไม่', //是否提交数据
    specialA: 'ชิ้น', //件

    // 822
    EditUser: 'แก้ไขผู้ใช้', //编辑用户
    PleaseLeast1ItemPerLevel: 'ต้องมีสินค้าอย่างน้อย 1 ชิ้นในแต่ละด่าน', //每关请至少设置1个任务商品！
    PleaseLeastTwoLevels: 'ต้องมีอย่างน้อย 2 ด่าน', //请至少设置两关！
    ServiceOrderNumber: 'หมายเลขบริการ', //服务单号
    MenuName: 'ชื่อเมนู', //菜单名称
    MenuProgression: 'ระดับเมนู', //菜单级数
    FrontEndName: 'ชื่อรหัส', //前端名称
    FrontEndIcon: 'ไอคอน', //前端图标
    ShoworNot: 'ต้องการแสดงหรือไม่', //是否显示
    sort: 'ลำดับ', //排序
    Settings: 'ตั้งค่า', //设置
    ViewSubordinates: 'ดูหมวดย่อย', //查看下级
    UpperMenu: 'เมนูหมวดหลัก:', //上级菜单：
    ResourceName: 'ชื่อเรียกทรัพยากร', //资源名称
    ResourcePath: 'เส้นทางทรัพยากร', //资源路径
    ResourceClassification: 'แบ่งประเภททรัพยากร', //资源分类
    PleaseSelectMenu: 'กรุณาเลือกเมนู', //请选择菜单
    clear: 'ล้าง', //清空
    // 830
    LabelOption: 'ตัวเลือก', //标签选项
    EditSwitchPricingMethod: 'ในโหมดแก้ไขจะไม่สามารถเปลี่ยนวิธีการคำนวณได้', //编辑状态不可切换计价方式！
    EditSwitchPricingMethod2: 'เมื่อเปลี่ยนวิธีการคำนวณแล้ว ข้อมูลที่ใส่ไว้ก่อนหน้าจะถูกล้างทั้งหมด ยืนยันทำต่อหรือไม่', //切换计价方式后，所设置当前模板的运输信息将被清空，确定继续么？
    weightChose: 'น้ำหนัก', //重量
    WeightAmountChose: 'น้ำหนัก+จำนวนเงิน', //重量+金额
    AmountChose: 'จำนวนเงิน', //金额
    pieceChose: 'จำนวนชิ้น', //件数
    pieceAmountChose: 'จำนวนชิ้น+จำนวนเงิน', //件数+金额
    StoreAudit: 'ตรวจสอบร้านค้า', //店铺审核
    ShopInformation: 'ข้อมูลร้านค้า', //店铺信息
    PleaseStoreBrandBusinessInformation: 'กรุณาตรวจสอบแบรนด์ร้านค้าและข้อมูลกิจการให้ถูกต้อง', //请确认店铺品牌及经营信息
    BrandInformation: 'ข้อมูลแบรนด์', //品牌信息
    LevelReward: 'รางวัลด่าน', //关卡奖励

    // 9-8
    OperationalEntry: 'เข้าสู่ระบบ', //运营登录
    entry: 'เข้าสู่ระบบ', //登录
    ByContinuReadAgree: 'ดำเนินการต่อหากคุณยอมรับ', //继续即表示您已阅读并同意
    MXCOMEWord: 'ข้อตกลงการใช้บริการของ MXCOME และนโยบายความเป็นส่วนตัว', //《MXCOME商家服务协议与隐私政策》
    PleaseSelectLoginShop: 'กรุณาเลือกร้านค้าที่ต้องการเข้าสู่ระบบ' //请选择登录店铺
  },
  //  1.5.5 调价
  adjustPrice: {
    onSale: 'วางขายอยู่', //在售中
    soldOut: 'ขายหมดแล้ว', //已售罄
    cumulativeSales: 'ยอดขายสะสม', //累计销量
    shelfStatus: 'สถานะการวางขาย', //上架状态
    FreeOrNot: 'เป็นของขวัญหรือไม่', //是否赠品
    ReleaseGoods: 'โพสต์สินค้า', //发布商品
    SupplyPriceAdjustment: 'ปรับราคาต้นทุน', //供货价调价
    ShelfBulk: 'วางขายหลายรายการ', //批量上架
    BatchRemoval: 'ยกเลิกวางขายหลายรายการ', //批量下架
    notSet: 'ยังไม่ตั้งค่า', //未设置
    ModifyPrice: 'แก้ไขราคา', //修改价格
    totalSalesVolume: 'ยอดขายทั้งหมด', //总销量
    video: 'วิดีโอ', //视频
    review: 'ตรวจสอบอีกครั้ง', //重新审核
    supplyPriceAdjustRequestForm: 'คำขอปรับราคาต้นทุน', //供货价调价申请单
    originalSupplyPrice: 'ราคาต้นทุนเดิม', //原供货价
    currentSupplyPrice: 'ราคาต้นทุนใหม่', //现供货价
    EffectiveDate: 'วันที่มีผลใช้', //生效日期
    ProductID: 'ไอดีสินค้า', //商品ID
    GoldRushPriceAdjust: 'ปรับราคาMXCOME', //淘金价调价
    commodityInformation: 'ข้อมูลสินค้า', //商品信息
    shop: 'ร้านค้า', //店铺
    product: 'สินค้า', //商品
    giveaway: 'ของขวัญ', //赠品

    // 9-19
    appGoldPriceAdjust: 'คำขอปรับราคาMXCOME', //淘金价调价申请单
    originalPanningPrice: 'ราคาMXCOMEเดิม', //原淘金价
    cashRushPrice: 'ราคาMXCOMEใหม่', //现淘金价
    priceAdjustmentApplicationTime: 'เวลายื่นคำขอ', //调价申请时间
    priceAdjustmentNumber: 'เลขที่คำขอ', //调价单号
    supplyPriceAdjustmentListNumber: 'เลขที่คำขอปรับราคาต้นทุน', //供货价调价单号
    AuditTime: 'เวลาตรวจสอบ', //审核时间
    auditStatus: 'สถานะการตรวจสอบ', //审核状态
    auditor: 'ผู้ตรวจสอบ', //审核人
    typePriceAdjustment: 'ประเภทการปรับราคา', //调价类型
    EffectiveTime: 'เวลาที่มีผลใช้', //生效时间
    goldPriceAdjustOrderNumber: 'เลขที่คำขอปรับราคาMXCOME', //淘金价调价单号
    passivePriceAdjust: 'ร้านค้าปรับราคา', //被动调价
    voluntaryPriceAdjust: 'แอดมินปรับราคา', //主动调价
    platformServiceFee: 'ค่าบริการแพลตฟอร์ม', //平台服务费
    TalentAward: 'รางวัลMXWINNER', //达人奖励
    priceAdjustmentInformation: 'รายละเอียดคำขอ', //调价单信息
    supplyPriceAdjustmentInformation: 'รายละเอียดคำขอปรับราคาต้นทุน', //供货价调价单信息
    supplyPriceAdjustDetailsPanPriceSet: 'ตั้งค่าข้อมูลการปรับราคาต้นทุนและราคาMXCOME', //供货价调价详情及淘金价设置
    panningPriceSet: 'ตั้งค่าราคาMXCOME', //淘金价设置
    commoditiesPriceAdjust: 'สินค้าที่ปรับราคาแล้ว', //已调价的商品
    productPicture: 'ภาพสินค้า', //商品图片
    priceAdjustmentRatio: 'อัตราการปรับราคา' //调价比率
  },
  //  开通品牌，店铺
  openBrandShop: {
    phone: 'เบอร์โทรศัพท์', //电话
    AdministratorName: 'ชื่อ-สกุลผู้ดูแล', //管理员姓名
    AdministratorPhone: 'เบอร์ติดต่อผู้ดูแล', //管理员电话
    AdministratorEmail: 'อีเมลผู้ดูแล', //管理员邮箱
    affidavitTime: 'วันหมดอายุหนังสือรับรองบริษัท', //宣誓书到期时间
    AboutExpire: 'ใกล้ถึงวันหมดอายุ', //即将到期
    ExpiredLicense: 'หมดอายุ', //证照过期
    abnormal: 'ไม่ปกติ', //异常
    SupplementaryInformation: 'เอกสารเพิ่มเติม', //补充资料
    uploadBanner: 'อัปโหลดรูปแบนเนอร์', //上传banner图
    AdministratorInformation: 'ข้อมูลผู้ดูแล', //管理员信息
    mobile: 'เบอร์โทรศัพท์', //手机
    MailingAddress: 'ที่อยู่สำหรับรับเอกสาร', //邮寄地址
    maximum30Characters: 'สูงสุดไม่เกิน 30 ตัวอักษร', //最多不超过30个字符
    openBrandShopTip1: 'กรุณากรอกข้อความแนะนำร้านค้าที่จะแสดงบนแอปพลิเคชัน หมายเหตุ: สามารถแก้ไขได้เพียงเดือนละ 1 ครั้ง', //请填写店铺介绍，展示APP品牌店铺简介。注意：每月仅修改一次，请认真填写
    SelectiveClassification: 'เลือกหมวดหมู่', //选择分类
    haveClassification: 'เลือกหมวดหมู่', //选择分类
    NewCategory: 'เพิ่มหมวดหมู่', //新增分类
    CauseRejection: 'เหตุผลการปฏิเสธ', //驳回原因
    reEdit: 'แก้ไขอีกครั้ง', //重新编辑
    recertification: 'ยืนยันตัวตนอีกครั้ง', //重新认证
    DataAuthentication: 'ยืนยันข้อมูล', //资料认证
    openBrandShopTip2: 'กรุณาอัปโหลดเอกสารตามความเป็นจริง คุณสามารถเพิ่มเติมเอกสารได้หลังจากเปิดใช้งานร้านค้า', //请根据实际情况上传相关资料，您也可激活店铺后补充
    BrandInformation: 'ข้อมูลแบรนด์', //品牌资料
    BrandParty: 'ฝ่ายแบรนด์', //品牌方
    JointVentureCompany: 'กิจการร่วมค้า', //合资公司
    StateAgent: 'ตัวแทนจำหน่ายต่างประเทศ', //国家代理
    TrademarkApplication: 'หนังสือจดทะเบียนเครื่องหมายการค้า', //商标申请书
    brandTrademarkAuthorization: '(แบรนด์)หนังสืออนุญาตให้ใช้เครื่องหมายการค้า', //(品牌)商标授权书
    TrademarkCertificate: 'ใบทะเบียนเครื่องหมายการค้า', //商标证书
    CompanyInformation: 'ข้อมูลบริษัท', //公司资料
    SupportingMaterial: 'เอกสารอื่นๆ', //证明材料
    SignatureDirector: 'กรรมการลงลายมือชื่อ', //董事签署
    AuthorizedSignature: 'ผู้รับมอบอำนาจลงลายมือชื่อ', //授权签署
    CertificateIncorporation: 'ใบจดทะเบียนบริษัท', //公司登记证书
    CompanyCertificateNumber: 'เลขที่ใบจดทะเบียนบริษัท', //公司登记证书号
    // 10-14
    Limited30Characters: 'ไม่เกิน 30 ตัวอักษร', //限30个字符
    companyAffidavit: 'หนังสือรับรองบริษัท', //公司宣誓书
    EffectiveCutoffTime: 'ใช้ได้ถึงวันที่', //有效截止时间
    VATRegistrationCertificate: 'ใบจดทะเบียนภาษีมูลค่าเพิ่ม', //增值税登记证
    VATregistrationNumber: 'เลขที่ใบจดทะเบียนภาษีมูลค่าเพิ่ม', //增值税登记号码
    openBrandShopTip3: 'เอกสารที่ต้องอัปโหลด: ภ.พ.20 (บริษัทเปิดใหม่ใช้เอกสาร ภ.พ.01)', //上传证照为：ภ.พ. 20 （新公司就提供ภ.พ.01）
    DirectorPowerAttorney: 'หนังสือมอบอำนาจ', //董事授权书
    NameDirectorNameAuthorizRepresent: 'ชื่อกรรมการ หรือผู้รับมอบอำนาจ', //董事名字，授权代表名字
    ImmediateAuthentication: 'ยืนยันทันที', //立即认证
    ApplicantInformation: 'ข้อมูลผู้ยื่น', //申请人信息
    BrandOwnership: 'เจ้าของแบรนด์', //品牌所有
    RelatedWebsite: 'เว็บไซต์', //相关网站
    NameAuthoriRepresent: 'ชื่อกรรมการ หรือผู้รับมอบอำนาจ', //董事名字、授权代表名字
    goNext: 'ข้าม', //跳过
    CertificationData: 'เอกสารเพิ่มเติม', //认证资料
    BrandStoreName: 'ชื่อแบรนด์/ร้านค้า', //品牌/店铺名称
    AuditType: 'ประเภทการตรวจสอบ', //审核类型
    AddBalance: 'กรอกยอดเงิน', //添加余额
    UserRegistrationCreationTime: 'เวลาที่ผู้ใช้ลงทะเบียน/สร้างบัญชี', //用户注册/创建时间
    AcquisitionChannel: 'ช่องทางการรับ', //获取通道
    SubscriberMobilePhoneNumber: 'เบอร์โทรศัพท์', //用户手机号
    userName: 'ชื่อ-สกุลผู้ใช้', //用户姓名
    firstPurchaseTime: 'เวลาที่สั่งซื้อครั้งแรก', //首单购买时间
    WhetherRedEntryQualification: 'มีคุณสมบัติฝ่าด่านพิชิตอั่งเปาหรือไม่', //是否有红包闯关资格
    inviter: 'ผู้เชิญ', //邀请人
    UserNickname: 'ชื่อเล่นผู้ใช้', //用户昵称
    OpenBetaInvitationCode: 'รหัสเชิญสำหรับการทดสอบ', //公测邀请码
    RedEnvelopeEntryInvitationCode: 'รหัสเชิญฝ่าด่านพิชิตอั่งเปา', //红包闯关邀请码
    ShareBuying: 'การซื้อผ่านลิงก์', //分享购买
    InvitationInvitationCode: 'รหัสเชิญการ์ดเชิญ', //邀请函邀请码
    RedEnvelopeQualificaManagement: 'จัดการคุณสมบัติอั่งเปา', //红包资格管理
    RedEnvelopeQualificaManagement2: 'แบบฟอร์มการจัดการหลังบ้านสำหรับคุณสมบัติฝ่าด่านพิชิตอั่งเปา ผู้ดำเนินการสามารถเพิ่มคุณสมบัติฝ่าด่านพิชิตอั่งเปาให้กับผู้ใช้ได้', //红包闯关资格后台管理模块，运营还可以通过此模块手动给用户添加红包闯关资格
    TotalOrderNumber: 'จำนวนคำสั่งซื้อทั้งหมด', //总订单数
    totalNumberPackages: 'จำนวนสินค้าทั้งหมด', //总件数
    TotalAmountGoldPanningSales: 'ยอดขายจากMXGETทั้งหมด', //淘金销售总金额
    TotalAmountRedPacketsMasterLevel: 'ยอดรวมอั่งเปาของMXWINNER', //达人层级红包总金额
    TalentPromotionAward: 'รางวัล MXWINNER', //达人推广奖励
    balanceTalentAccountRecorded: 'ยอดเงินเข้าบัญชี MXWINNER', //达人账户余额入账
    MasterGoldReward: 'รางวัล MXCOIN', //达人金币奖励
    numberReturnedItems: 'จำนวนการคืนสินค้าทั้งหมด', //退货总件数
    TotalAmountReturned: 'ยอดเงินจากการคืนสินค้าทั้งหมด', //退货总金额
    bindingBankcardTip1: 'กรุณาเลือกธนาคารให้ตรงกับบัตรธนาคารของคุณ ระบบจะเพิ่มข้อมูลธนาคารอัตโนมัติ', //绑定银行卡时需要选择银行卡对应的银行，该模块主要是在系统后台自定义添加银行信息
    AddBank: 'เพิ่มบัตร', //添加银行
    BankAbbreviation: 'ชื่อย่อธนาคาร', //银行简称
    BankLogo: 'โลโก้ธนาคาร', //银行Logo
    lengthCannotExceed60Characters: 'ความยาวไม่เกิน 60 ตัวอักษร', //长度不超过60个字符
    lengthCannotExceed20Characters: 'ความยาวไม่เกิน 20 ตัวอักษร', //长度不超过20个字符
    PleaseFillBankAbbreviat: 'กรุณากรอกชื่อย่อธนาคาร', //请填写银行简称
    PleaseFillBankLogo: 'กรุณาใส่โลโก้ธนาคาร', //请填写银行Logo
    LoginAccount: 'บัญชีสำหรับเข้าสู่ระบบ', //登录账号
    hongbaoEligibilityPeriod: 'จำกัดระยะเวลาคุณสมบัติอั่งเปา', //红包资格期限
    addedRedPacketEntryQualificate: 'เพิ่มคุณสมบัติฝ่าด่านพิชิตอั่งเปา', //添加红包闯关资格
    ManualAddition: 'ป้อนข้อมูล', //手动添加
    EligibilityPeriod: 'ระยะเวลาคุณสมบัติ', //资格有效期
    QuantityAudited: 'จำนวนที่รอตรวจสอบ', //待审核数量

    // 10-16
    WhetherSetUpLocalOperatCompany: 'จดทะเบียนบริษัทในประเทศแล้วหรือไม่', //是否设立本地运营公司
    copyTip1: 'คัดลอกแล้ว', //复制链接成功
    englishOrNum: 'เฉพาะตัวเลขและตัวอักษรภาษาอังกฤษเท่านั้น', //只能为数字或英文
    Num30: 'ไม่เกิน 30 ตัว', //不能超过30个字符
    GoldRushSalesPaidOut: 'ยอดขายสุทธิจาก MXGET', //淘金销售实付金额
    // 10-23
    OnlyMP4FormatSupportedTips: 'รองรับเฉพาะ .mp4 ขนาดไฟล์ไม่เกิน 50MB แนะนำภาพวิดีโอขนาด 1080*1400', //仅支持MP4格式，视频大小不可超过10M，建议视频尺寸为1080*1400或等比例为最佳
    InvitationLetter1: 'การ์ดเชิญ', //邀请函
    InvitationLetter: 'เปิดใช้งานดำเนินการแบรนด์ด้วยตนเอง', //开启品牌自营
    OpenBrandStore: 'เปิดร้านค้า', //开通品牌店铺
    ContactName: 'ชื่อ-สกุลผู้ติดต่อ', //联系人姓名
    // 10-23下午
    copyTip2: 'คัดลอกลิงก์', // 复制链接
    picTips: 'ขนาดรูปภาพไม่เกิน 3MB สูงสุด 5 รูป รองรับไฟล์ .jpg .png และ .bmp', //单张图片大小不超过3MB，最多上传5张，支持jpg、png、bmp格式
    editNot: 'รูปแบบคุณสมบัติมีการแก้ไขอยู่ ไม่สามารถแก้ไขได้', //编辑状态规格模板不可被编辑！
    Not60String: 'ความยาวไม่เกิน 60 ตัว', //长度不超过 60 个字符
    Not100String: 'ความยาวไม่เกิน 100 ตัว', //长度不超过 100 个字符
    AudiComplete: 'ตรวจสอบสำเร็จ!', //审核完成!
    activeAuth: 'ตรวจสอบกิจกรรม', //活动审核
    userAuth: 'ตรวจสอบการยืนยันตัวตนผู้ใช้', //用户实名审核
    shopBrandAuth: 'ตรวจสอบร้านค้า', //品牌店铺审核
    proAuth: 'ตรวจสอบสินค้า', //商品审核
    SupplyPriceAdjustReview: 'ตรวจสอบการตั้งราคาต้นทุน', //供货价调价审核
    GoldRushPriceAdjustReview: 'ตรวจสอบการตั้งราคา MXCOME', //淘金价调价审核
    BrandApplicatReview: 'ตรวจสอบคำขอแบรนด์', //品牌申请审核
    ServiceApplicatFollowUp: 'ติดตามคำขอใช้บริการ', //服务申请跟进
    EnterMultipleQueriesSequenceSeparatedCommas: 'หากต้องการค้นหามากกว่า 1 กรุณาใส่สัญลักษณ์จุลภาค (,) คั่นข้อความ', //多个查询请逗号隔开依次输入
    PleaseEnterEffectiveDate: 'กรุณากรอกวันที่มีผลบังคับใช้', //请输入生效日期
    PleaseSelectProduct: 'กรุณาเลือกสินค้า!', //请选择商品！
    PleaseFillCashPanPrice: 'กรุณากรอกราคา MXCOME ปัจจุบัน!', //请填写现淘金价！
    PleaseFillCashPanPriceTip2: 'ราคา MXCOME ปัจจุบันต้องสูงกว่าราคาต้นทุนปัจจุบัน มิฉะนั้นอาจทำให้ขาดทุน!', //现淘金价必须大于现供货价，否则会造成资损！
    PleaseFillCashPanPriceTip3: 'ส่งคำขอตั้งราคา MXCOME แล้ว!', //淘金价调价申请成功！
    PleaseFillCashPanPriceTip4: 'สินค้านี้ได้ส่งราคาตรวจสอบแล้ว หากส่งคำขอซ้ำจะอิงราคาล่าสุดที่ส่งคำขอเป็นหลัก', //商品已经提交了一个待审核的调价单，本次再次提交调价申请，会以最近一次提交的价格为准
    PleasFillCurrentSupplyPrice: 'กรุณากรอกราคาต้นทุนปัจจุบัน!', //请填写现供货价！
    SupplyPriceAdjustApplicatSuccessful: 'ส่งคำขอตั้งราคาต้นทุนแล้ว', //供货价调价申请成功

    PleaseEnterCouponName: 'กรุณากรอกชื่อคูปอง', //请输入优惠券名称
    PleaseEnterFaceValue: 'กรุณากรอกมูลค่าคูปอง', //请输入面值
    PleaseSelectEventProduct: 'กรุณาเลือกสินค้าในกิจกรรม', //请选择活动商品
    numPerlimitTip2: '发放数量应大于等于',
    // 10-25
    ContactInformation: 'ข้อมูลผู้ติดต่อ', //联系人信息
    BrandCategory: 'ประเภทสินค้า', //品牌类目
    RelevantData: 'เอกสารที่เกี่ยวข้อง', //相关资料
    ClickDownloadView: 'คลิกดาวน์โหลดเพื่อตรวจสอบ', //点击下载查看
    AdvertisingName: 'ชื่อโฆษณา', //广告名称
    AdvertisingPosition: 'ตำแหน่งที่ต้องการโฆษณา', //广告位置
    ActivityType: 'ประเภทกิจกรรม', //活动类型
    MaturityTime: 'วันที่สิ้นสุด', //到期时间
    OnlineOffline: 'ออนไลน์/ออฟไลน์', //上线/下线
    downline: 'ออฟไลน์', //下线
    TopLine: 'ออนไลน์', //上线
    AdvertisingPicture: 'ภาพโฆษณา', //广告图片
    AdvertisingLink: 'ลิงก์โฆษณา', //广告链接
    AdvertisementNote: 'หมายเหตุ', //广告备注
    PleaseEnterContent: 'กรุณาใส่เนื้อหา', //请输入内容
    PCHomePageRotation: 'เผยแพร่หน้าแรกเว็บไซต์', //PC首页轮播
    APPHomeCarousel: 'เผยแพร่หน้าแรกของแอปพลิเคชัน', //APP首页轮播
    AddAnAD: 'เพิ่มโฆษณา', //添加广告
    PleaseEnterADName: 'กรุณากรอกชื่อโฆษณา', //请输入广告名称
    PleaseEnterADLink: 'กรุณากรอกลิงก์โฆษณา', //请输入广告链接
    PleaseSelectStartTime: 'กรุณาเลือกวันที่เริ่ม', //请选择开始时间
    PleaseSelectExpirationTime: 'กรุณาเลือกวันที่สิ้นสุด', //请选择到期时间
    PleaseSelectAdvertiseImage: 'กรุณาเลือกภาพโฆษณา', //请选择广告图片
    GeneralAdvertise: 'โฆษณาทั่วไป', //普通广告
    ActivityAdvertise: 'โฆษณากิจกรรม', //活动广告
    VerificationFailure: 'ยืนยันตัวตนล้มเหลว', //验证失败
    time: 'เวลา', //时间
    clickTime: 'ยอดการคลิก', //点击次数
    GenerateOrder: 'สร้างคำสั่งซื้อ', //生成订单

    MxcomeText1: 'ฉันได้อ่านและยินยอม',
    MxcomeText2: 'ข้อตกลงการให้บริการร้านค้าของ MXCOME',
    MxcomeText3: 'สำหรับการสมัครเป็นผู้ขายอย่างเป็นทางการของ Mxcome',

    // 10-26
    PleaseEnterAccountNumber: 'กรุณากรอกบัญชี', //请输入账号
    PleaseEnterPassword: 'กรุณากรอกรหัสผ่าน', //请输入密码
    AccountNumberName: 'ชื่อบัญชี/ชื่อ-นามสกุล', //帐号/姓名
    ServiceType: 'ประเภทบริการ', //服务类型
    FillMobilePhoneNumberMasterRegistrate: 'กรอกเบอร์โทรศัพท์ที่ MXWINNER ลงทะเบียน', //填写达人注册的手机号
    EnglishNumberMaximum30Characters: 'ภาษาอังกฤษ ตัวเลข หรือทั้งภาษาอังกฤษและตัวเลข สูงสุดไม่เกิน 30 ตัว', //英文、数字、英文+数字，最多不超过30个字符
    memberPhone: 'เบอร์โทรศัพท์ MXWINNER', //达人手机号
    inputMemberPhone: 'กรุณากรอกเบอร์โทรศัพท์ MXWINNER', //请输入达人手机号
    Up60Characters: 'สูงสุด 60 ตัว', //最多60个字符
    EditSaveSuccess: 'บันทึกการแก้ไขสำเร็จ!', //编辑保存成功！
    PleaseSelectStoreFirstProceedOperation: 'กรุณาเลือกร้านค้าก่อนดำเนินการ', //请先选择店铺后，再进行操作！
    WhetherDeleteBank: 'ต้องการลบธนาคารดังกล่าวหรือไม่', //是否要删除该银行?
    delSuccess: 'ลบสำเร็จ!', //删除成功！
    editBank: 'แก้ไขธนาคาร', //编辑银行
    ServiceName: 'ชื่อการบริการ', //服务名称
    AuditDetails: 'รายละเอียดการตรวจสอบ', //审核详情
    HaveEntered: 'เข้าร่วมแล้วหรือไม่', //是否已入驻
    numPerlimitTip: 'จำนวนกับยอดจำกัดแต่ละวันควรมากกว่าหรือเท่ากับ 1', //发放数量和每天限兑需大于等于1的正整数！
    numPerlimitTip3: 'สินค้านี้ได้ส่งราคาตรวจสอบแล้ว หากส่งคำขอซ้ำจะอิงราคาล่าสุดที่ส่งคำขอเป็นหลัก', //商品已经提交了一个待审核的调价单，本次再次提交调价申请，会以最近一次提交的价格为准

    // 10-28
    innerBox: 'ภายใน', //内部
    NetRedEnvelopeEntryThreeValue: 'มูลค่าอั่งเปารวมทั้ง 3 ด่าน', //网红达人红包闯关资格三关总价值
    FillOutSeveralTimes: 'แบ่งถอนเงินหลายครั้ง', //分几次提现
    times: 'ครั้ง', //次
    numberTimesMustEqualAmountBonus: 'จำนวนครั้งจะต้องหารจำนวนเงินของรางวัลลงตัว', //次数必须能被奖励红包金额整除
    PleaseFillLogisticsCompanyCode: 'กรุณาใส่โค้ดบริษัทขนส่ง', //请填写物流公司Code
    PleaseFillLogoLogisticsCompany: 'กรุณาใส่โลโก้บริษัทขนส่ง', //请填写有物流公司Logo
    SoldOut: 'ขายหมดแล้ว', //已售磬
    DoDeleteLogisticsCompany: 'ต้องการลบบริษัทขนส่งดังกล่าวหรือไม่', //是否要删除该物流公司?
    cumulativeSalesIntegerGreaterEqual: 'ยอดขายสะสมต้องเป็นจำนวนเต็มที่มากกว่าหรือเท่ากับ 0', //累计销量需为大于等于0的整数！
    EditorialLogisticsCompany: 'แก้ไขบริษัทขนส่ง', //编辑物流公司
    SetArea: 'ตั้งค่าพื้นที่', //设置地区
    volume: 'ปริมาตร', //体积
    VolumeAmount: 'ปริมาตร+จำนวนเงิน', //体积+金额
    AreWantDeleteSettingsCurrentRegion: 'ยืนยันลบการตั้งค่าพื้นที่ก่อนหน้านี้หรือไม่', //确认要删除当前地区的设置吗？
    BrandProfileChange: 'แก้ไขคำแนะนำแบรนด์', //品牌简介更改
    StoreProfileChange: 'แก้ไขคำแนะนำร้านค้า', //店铺简介更改
    CertificationDataSupplement: 'เพิ่มเอกสารเพิ่มเติม', //认证资料补充
    FailAudit: 'ไม่ผ่านการตรวจสอบ', //审核未通过
    inventoryQuantityNoExceed: 'จำนวนในคลังสินค้าต้องไม่เกิน', //库存数量不能超过

    // 10-27
    inputCode: 'Please enter the verification code!', //请输入验证码！
    choseIDcardValidate: 'Please select the validity period of ID card', //请选择身份证有效期
    applicationSuccess: 'Application successful!', //申请成功！
    LevelsMustConsecutive2Level: 'Levels should be consecutive and not less than two!', //关卡要连续且不能小于两关！
    endDateGreaterStartDate: 'The end date has to be later than the start date!', //结束日期要大于开始日期！
    endDate7DaysOlderStartDate: 'The end date cannot be later than the start date by more than 7 days!', //结束日期不能大于开始日期超过7天！
    taskProdect13spu: 'Task products can only have 1-3 spu products per level!', //任务商品每关只能有1-3个spu商品！
    taskProductStock: 'The inventory of the task item cannot be empty!', //任务商品库存不能为空！
    pleaseChoseNumber: 'Please choose a ranking reward', //请选择排名奖励
    numberPriceOrStockNull: 'Ranking reward price or giveaway inventory is empty', //排名奖励价格或赠品库存为空
    numberStartNEndNull: 'Starting or ending rank of ranking rewards is empty!', //排名奖励开始名次或结束名次为空！
    numberPriceBigEndStart: 'Ranking Reward Inventory needs to be greater than the difference between the ending rank and the starting rank!', //排名奖励库存需要大于结束名次与开始名次之差！
    relaythetask: 'You have relayed this task. Go to the app and share it with your friends', //您已接力此任务，快去APP分享给好友

    // 11-1
    ViewExamples: 'ดูตัวอย่าง', //查看示例
    certificateInformatSubmitSuccess: 'ส่งเอกสารสำเร็จแล้ว ใช้เวลาตรวจสอบภายใน 48 ชั่วโมง สามารถโพสต์สินค้าได้หลังจากผ่านการตรวจสอบแล้ว!', //认证资料提交成功，将在48小时内审核完毕，审核通过后，才能上架商品！
    toDoThisDelete: 'ยืนยันการลบหรือไม่', //是否要进行该删除操作?
    activatStoreAuthenticatInformatSuccessfulSubmit: 'ส่งเอกสารประกอบการเปิดร้านค้าสำเร็จแล้ว ใช้เวลาตรวจสอบภายใน 48 ชั่วโมง สามารถโพสต์สินค้าได้หลังจากผ่านการตรวจสอบแล้ว!', //激活店铺认证信息提交成功，将在48小时内审核完毕，审核通过后，才能创建商品！
    activatStoreAuthenticatInformatSuccessfulSubmit2: 'เพื่อเพิ่มประสิทธิภาพการรักษาผลประโยชน์ของท่าน กรุณาอ่านข้อตกลงด้านล่างนี้อย่างละเอียด', //为了更好地保障您的合法权益，请阅读以下协议:
    brandInfoAgain: 'ส่งคำแนะนำแบรนด์อีกครั้งสำเร็จแล้ว ใช้เวลาตรวจสอบภายใน 48 ชั่วโมง!', //品牌简介重新认证提交成功，将在48小时内审核完毕！
    brandInfoAgain2: 'โปรดอัปเดตหนังสือรับรองก่อนถึงวันหมดอายุ มิฉะนั้นสินค้าทั้งหมดจะถูกเอาออกจากชั้นวาง!', //宣誓书到期前，需要在【补充资料】更新宣誓书，否则所有商品会全部下架无法正常销售！
    home: 'หน้าแรก', //首页
    quit: 'ออกจากระบบ', //退出
    CloseOther: 'ปิดหน้าอื่น', //关闭其他
    CloseAll: 'ปิดทั้งหมด', //关闭所有
    AlreadyEnter: 'เข้าร่วมแล้ว', //已入驻
    NotYetEnter: 'ยังไม่เข้าร่วม', //未入驻
    corporateServices: 'บริการกิจการ', //企业服务
    OperationService: 'บริการดำเนินการ', //运营服务
    package: 'พัสดุ', //包裹
    selfSupport: 'ดำเนินการด้วยตนเอง', //自营
    BatchImport: 'นำเข้าหลายรายการ', //批量导入
    DownloadTemplate: 'ดาวน์โหลดรูปแบบ', //下载模板
    ToLeadInto: 'นำเข้า', //导入
    ImportList: 'นำเข้ารายการ', //导入名单
    CouponCodeInformat: 'ข้อมูลรหัสคูปอง', //券码信息
    zhangCan: 'ใบ สามารถใช้ได้', //张可用

    // 11-2
    NewFirstLevelClassificat: 'เพิ่มหมวดหมู่หลัก', //新增一级分类
    EditPrimaryClassifica: 'แก้ไขหมวดหมู่หลัก', //编辑一级分类
    EditPrimaryClassifica2: 'แก้ไขหมวดหมู่ย่อย', //编辑二级分类
    EditFirstClassificatGoods: 'แก้ไขหมวดหมู่หลักสินค้า', //编辑商品一级分类
    EditCommoditSecondaryClassificat: 'แก้ไขหมวดหมู่ย่อยสินค้า', //编辑商品二级分类
    CategoryNamecn: 'ชื่อหมวดหมู่(cn)', //分类名称(cn)
    CategoryNameen: 'ชื่อหมวดหมู่(en)', //分类名称(en)
    CategoryNameth: 'ชื่อหมวดหมู่(th)', //分类名称(th)
    PrimaryClassificatCommoditiesCn: 'หมวดหมู่หลักสินค้า(cn)', //商品一级分类(cn)：
    PrimaryClassificatCommoditiesEn: 'หมวดหมู่หลักสินค้า(en)', //商品一级分类(en)：
    PrimaryClassificatCommoditiesTh: 'หมวดหมู่หลักสินค้า(th)', //商品一级分类(th)：
    guigeData: 'ข้อมูลคุณสมบัติ', //规格数据
    guigeName: 'ชื่อคุณสมบัติ', //规格名称
    choseList: 'รายการตัวเลือก', //可选列表
    addNewParam: 'เพิ่มรายละเอียดเพิ่มเติม', //新增参数
    addNewGuige: 'เพิ่มคุณสมบัติ', //新增规格
    // 11-3
    ManualInput: 'ป้อนข้อมูล',
    SelectBox: 'ตัวเลือก',
    PleaseSelectRegion: 'กรุณาเลือกพื้นที่ที่ต้องการจัดการหลายรายการ  ',
    TicketCodeNumber: 'รหัสคูปอง',
    AlreadyExist: 'มีอยู่แล้ว',
    needDeleteDataImportTemplateImportAgain: 'ต้องลบรหัสคูปองดังกล่าวออกจากไฟล์ก่อน แล้วลองนำเข้าไฟล์อีกครั้ง',
    NetRedTalentRedEnvelopeCrosTask: 'ตั้งค่าภารกิจฝ่าด่านพิชิตอั่งเปาสำหรับ MXWINNER KOL',
    // 11-9
    activatStoreAuthenticatInformatSuccessfulSubmit2: 'เพื่อเพิ่มประสิทธิภาพในการปกป้องสิทธิตามกฎหมายของท่านได้ดียิ่งขึ้น โปรดอ่านและยอมรับข้อตกลงดังต่อไปนี้', //为了更好地保障您的合法权益，请阅读并同意以下协议:
    PleaseEnterYourName: 'กรุณากรอกชื่อ-สกุล', //请输入姓名
    PleaseEnterYourContactEmail: 'กรุณากรอกอีเมล', //请输入联系邮箱
    congeniality: 'ยอมรับ', //同意
    PleaseUploadStoreLogo: 'กรุณาอัปโหลดโลโก้ร้านค้า', //请上传店铺logo
    PleaseFillFullAddress: 'กรุณากรอกรายละเอียดที่อยู่', //请填写详细地址
    PleaseFillLeastOneField: 'กรุณากรอกอย่างน้อย 1 ข้อ หรือกดข้ามขั้นตอนนี้', //请至少填写一项内容后再提交，否则请点跳过！
    PleaseFillTheCategory: 'กรุณากรอกประเภทสินค้า!', //请填写分类！
    DuplicateBrandName: 'ชื่อแบรนด์ซ้ำ!', //品牌名称重复！
    PleaseSelectCategory: 'กรุณาเลือกประเภทสินค้า', //请选择分类
    PleaseFillMailAddressCareful: 'กรุณากรอกที่อยู่!', //请认真填写邮寄地址！
    // 11-10
    PleaseEnterActivityName: 'กรุณากรอกชื่อกิจกรรม', //请认真填写邮寄地址！
    PleaseEnterActivitySubtitle: 'กรุณากรอกหัวข้อย่อยกิจกรรม', //请输入活动副标题
    lengthBetween140Characters: 'ความยาวตั้งแต่ 4 ถึง 140 ตัวอักษร', //长度在 4 到 140 个字符
    // 11-15
    FeedbackPerson: 'ผู้เสนอแนะ', //反馈人
    FeedbackTime: 'วันที่และเวลาที่เสนอแนะ', //反馈时间
    FeedbackType: 'ประเภทที่เสนอแนะ', //反馈类型
    source: 'แหล่งที่มา', //来源
    ImprovementSuggest: 'แนะนำเกี่ยวกับการพัฒนา', //改进建议
    Off: 'ปิด', //关闭
    SupplyPriceAdjustRequestSubmit: 'ส่งคำขอปรับราคาต้นทุนสินค้าสำเร็จ', //供货价调价申请单提交成功
    PleaseEnterTemplateName: 'กรุณากรอกชื่อแบบ', //请输入模板名称
    PleaseSelectShipAddress: 'กรุณาเลือกที่อยู่จัดส่ง', //请选择发货地址
    AreWantDeleteSetCurrentRegion: 'ยืนยันลบการตั้งค่าในพื้นที่ดังกล่าวหรือไม่', //确认要删除当前地区的设置么？
    MerchandiseReconciliaState: 'รายงานรายการสินค้า', //商品对账表
    SalesStatement: 'รายงานยอดขาย', //销量报表
    InventoryWarning: 'แจ้งเตือนสต็อกสินค้า', //库存预警
    InventoryInquiryReport: 'รายงานตรวจสอบคลัง', //库存查询报表
    AfterSalePendingReview: 'กำลังตรวจสอบบริการหลังการขาย', //售后待审核
    Limited60Characters: 'จำกัด 60 ตัวอักษร', //限60个字符
    InteractiveSuggest: 'แนะนำเกี่ยวกับการใช้', //交互建议
    FunctionalSuggest: 'แนะนำเกี่ยวกับฟังก์ชัน', //功能建议
    BUGSubmission: 'แจ้งปัญหาบัค', //BUG提交
    others: 'อื่นๆ', //其他
    ProductsMeetConditionsRemove: 'สินค้าไม่อยู่ในเงื่อนไขที่จะนำออกจากแอปพลิเคชัน ไม่สามารถนำออกได้!', //商品不符合下架条件，不能被下架!
    BowWeight: 'น้ำหนักช่วงแรก(กก.)', //首重量(kg)
    BowV: 'ขนาดช่วงแรก(ตร.ม.)', //首体积(m³)
    BowWSecond: 'น้ำหนักช่วงถัดไป(กก.)', //续重量(kg)
    BowVSecond: 'ขนาดช่วงถัดไป(ตร.ม.)', //续体积(m³)
    RedEnvelopeEntryTaskName: 'ชื่อภารกิจฝ่าด่านพิชิตอั่งเปา', //红包闯关任务名称
    EligibilityPeriodMandatory: 'จำเป็นต้องใส่ระยะเวลาคุณสมบัติ', //资格有效期为必填项
    Cleared: 'ปิดแล้ว', //已通关
    recoveredAfterBeingDeleted: 'หลังจากลบแล้ว ข้อมูลจะถูกลบถาวร กรุณาตรวจสอบความถูกต้อง!', //删除后，数据无法恢复，请谨慎操作！
    AgreeRefund: 'อนุมัติคืนเงิน', //同意退款
    CloseOrder: 'ยกเลิกคำสั่งซื้อ', //关闭订单
    sureAgreeRefund: 'ยืนยันอนุมัติคืนเงินหรือไม่', //确定同意退款？
    RefundSuccessful: 'คืนเงินสำเร็จ!', //退款成功！
    //  12-1
    ScheduleVisit: 'นัดหมายวันและเวลา', //预约来访时间
    MakeSureFollowService: 'ติดตามความคืบหน้ารายการนี้แล้ว', //确定已经跟进该项服务！
    FollowUpComplete: 'ติดตามความคืบหน้าสำเร็จ!', //跟进完成！
    WebNet: 'เว็บไซต์', //官网
    read: 'อ่านแล้ว', //已读
    readNot: 'ยังไม่ได้อ่าน', //未读
    CreateEditTime: 'เวลาที่สร้างหรือแก้ไข', //创建/编辑时间
    AddTask: 'เพิ่มภารกิจ', //添加任务
    nameSuper: 'ชื่อ', //名称
    choseTask: 'เลือกภารกิจ', //选择任务
    SelectedTask: 'ภารกิจที่เลือกไว้', //已选任务
    CommodityType: 'ประเภทสินค้า', //商品类型
    PackageGoods: 'สินค้าแพ็คเกจ', //套餐商品
    GeneralMerchandise: 'สินค้าทั่วไป', //普通商品
    EditingTask: 'แก้ไขภารกิจ', //编辑任务
    // 12-4
    welcome: 'ยินดีต้อนรับ', //欢迎
    WelcomeMXCOMEMerchantOperationConsole: 'ยินดีต้อนรับเข้าสู่ระบบดำเนินการร้านค้า MXCOME ', //欢迎来到MXCOME商家运营控制台
    ActivateBrandedStore: 'เปิดใช้งานร้านค้าของคุณ', //激活您的品牌店铺
    ProvidePutGoodsShelves: 'หากใส่เอกสารครบถ้วน หลังจากผ่านการตรวจสอบแล้ว จะสามารถโพสต์สินค้าได้', //提供完整的认证资料，审核通过后，即可上架商品
    ActivateNow: 'เปิดใช้งานทันที', //立即激活
    BrandStoreReviewed: 'คำขอเปิดใช้งานร้านค้าอยู่ระหว่างการตรวจสอบ', //品牌店铺开通待审核
    openingInformationBrandStore: 'ส่งเอกสารในการเปิดใช้งานร้านค้าเรียบร้อยแล้ว ใช้เวลาในการตรวจสอบเสร็จสิ้นภายใน 48 ชั่วโมง หากผ่านการตรวจสอบแล้ว จะสามารถโพสต์สินค้าได้', //品牌店铺开通资料已提交，将在48小时内审核完成，待审核通过后，即可上架商品
    setWarehousAddress: 'ตั้งค่าที่อยู่คลังสินค้า', //设置仓库地址
    setShipTemplates: 'ตั้งค่ารูปแบบค่าส่ง', //设置运费模板
    AddBrandStores: 'เพิ่มร้านค้า', //增设品牌店铺
    BrandManage: 'จัดการแบรนด์', //品牌管理
    ShopManage: 'จัดการร้านค้า', //店铺管理
    proManage: 'จัดการสินค้า', //商品管理
    taskManage: 'จัดการภารกิจ', //任务管理
    activeManage: 'จัดการกิจกรรม', //活动管理
    orderManage: 'จัดการคำสั่งซื้อ', //订单管理
    // 12-13
    MerchantName: 'ชื่อร้านค้า', //商家名称
    AreListItem: 'ยืนยันแสดงสินค้าดังกล่าวหรือไม่', //确定上架该商品？
    AreRemovePro: 'ยืนยันนำสินค้าดังกล่าวลงจากชั้นวางหรือไม่', //确定下架该商品？
    AreReviewPro: 'ยืนยันส่งสินค้าดังกล่าวตรวจสอบอีกครั้งหรือไม่', //确定重新审核该商品？
    AreDelPro: 'ยืนยันลบสินค้าดังกล่าวหรือไม่', //确定删除该商品？
    copyrightAuthorizaMng: 'จัดการคำขออนุญาตใช้ลิขสิทธิ์', //版权授权申请管理
    ClickDownloadView: 'คลิกดาวน์โหลดเพื่อดู', //点击下载查看
    PleaseSelectExpiratDate: 'กรุณาเลือกวันที่หมดอายุ', //请选择失效日期
    EnglishNumberMaximum10Characters: 'ตัวอักษรภาษาอังกฤษ ตัวเลข ตัวอักษรภาษาอังกฤษและตัวเลข สูงสุดไม่เกิน 10 ตัว', //英文、数字、英文+数字，最多不超过10个字符
    Num10: 'ต้องไม่เกิน 10 ตัว', //不能超过10个字符
    FollowUpStatus: 'สถานะการติดตามความคืบหน้า', //跟进状态
    republish: 'โพสต์อีกครั้ง', //再次发布
    uploadedVideoCannotEmpty: 'ไม่สามารถเว้นว่างในช่องอัปโหลดวิดีโอได้', //上传视频不能为空!
    salaryRangePositiveInteger: 'ช่องเงินเดือนกรุณาใส่เป็นจำนวนเต็ม', //薪资区间需为正整数!
    pleaseInputEnglish: 'กรุณากรอกภาษาอังกฤษ', //请输入英文!
    promoterRegisterMobileNumber: 'กรุณากรอกเบอร์โทรศัพท์ของผู้โปรโมท', //请输入推广人注册手机号!
    PleaseSelectStartDate: 'กรุณาเลือกวันที่เริ่ม', //请选择开始日期!
    PleaseSelectEndDate: 'กรุณาเลือกวันที่สิ้นสุด', //请选择结束日期!
    alliance: 'พันธมิตร', //联盟
    NoDoubleDigits: 'ต้องไม่เกิน 2 หลัก', //不能超过两位数!
    No3Digits: 'ต้องไม่เกิน 3 หลัก', //不能超过三位数!
    innerCode: 'รหัสเชิญภายใน', //内部邀请码

    // 12-18
    PromoterNickname: 'กรุณากรอกชื่อเล่นผู้โปรโมท', //请输入推广人昵称
    noMore50string: 'ไม่เกิน 50 ตัว', //不能超过50个字符
    lianceCode: 'รหัสเชิญพันธมิตร', //联盟邀请码
    thai: 'ประเทศไทย', //泰国
    china: 'ประเทศจีน', //中国
    salaryRangePositiveInteger2: 'ช่องเงินเดือนจะต้องเป็นจำนวนเต็ม', //薪资区间需为正数
    idcardNum2: 'เลขประจำตัวประชาชน/เลขที่หนังสือเดินทาง', //身份证/护照号码
    DeleteVideo: 'ลบวิดีโอ', //删除视频
    VideoDeletionSuccessful: 'ลบวิดีโอสำเร็จ', //视频删除成功!
    promoterRegisterMobileNumber: 'เบอร์โทรศัพท์ที่ผู้โปรโมทลงทะเบียน', //推广人注册手机号
    registerMobilePhoneNumber: 'กรอกเบอร์โทรศัพท์ที่ลงทะเบียน', //填写注册的手机号
    PromoterNickname2: 'ชื่อเล่นผู้โปรโมท', //推广人昵称
    promoterNicknameEnglishOnly: 'กรอกชื่อ-สกุลหรือชื่อเล่นของผู้โปรโมท เฉพาะภาษาอังกฤษเท่านั้น', //填写推广人的姓名或昵称，只能输入英文
    AuthorizationType: 'ประเภทสิทธิ์', //授权类型
    ApplicationType: 'ประเภทคำขอ', //申请类型
    articleReprint: 'คัดลอกบทความ', //文章转载
    ContenReference: 'ขอใช้เนื้อหา', //内容引用
    copyrightLicenseApplicationDetails: 'รายละเอียดคำขออนุญาตใช้ลิขสิทธิ์', //版权授权申请详情
    requirement: 'ความต้องการ', //需求
    FollowSuccessful: 'ติดตามความคืบหน้าสำเร็จ', //跟进成功
    influencerJoinApplicatDetails: 'รายละเอียดคำขอ KOL เข้าร่วม', //网红加入申请详情
    screenshotDayChannel: 'ภาพถ่ายหน้าจอแสดงข้อมูลช่องในวันนั้น', //当日频道截图
    ReleaseTime: 'วันที่ลงประกาศ', //发布时间
    Base: 'ฐาน', //Base地
    RecruitmentDepartment: 'แผนกรับสมัคร', //招聘部门
    JobTitle: 'ชื่อตำแหน่ง', //岗位名称
    DeliveryTime: 'เวลาจัดส่ง', //投递时间
    NatureWork: 'ลักษณะงาน', //工作性质
    ContactLocation: 'ที่อยู่ผู้ติดต่อ', //联系人所在地区
    EducationalRequire: 'วุฒิการศึกษา', //学历要求
    fullTime: 'งานประจำ', //全职
    PartTimeJob: 'งานพาร์ทไทม์', //兼职
    practice: 'ฝึกงาน', //实习
    PostReleaseTime: 'วันที่ประกาศตำแหน่งนี้', //岗位发布时间
    viewResume: 'ดูเรซูเม่', //查看简历
    PostJobRequirements: 'ประกาศความต้องการของตำแหน่งงาน', //发布岗位需求
    JobExperience: 'ประสบการณ์ที่เกี่ยวข้องกับตำแหน่งงาน', //岗位经验
    YearsMore: 'ปีขึ้นไป', //年以上
    SalaryRange: 'ระบุเงินเดือน', //薪资区间
    JobDescription: 'รายละเอียดงาน', //岗位描述
    FailureTime: 'วันที่สิ้นสุด', //失效时间

    // 12-21
    curriculumVitae: 'เรซูเม่', //简历
    JuniorCollege: 'วิทยาลัยอาชีวศึกษา', //大专
    SeniorHighSchool: 'มัธยมปลาย', //高中
    UndergraduateCourse: 'ปริญญาตรี', //本科
    master: 'ปริญญาโท', //硕士
    LearnedScholar: 'ปริญญาเอก', //博士
    PleaseSelectBasePlace: 'กรุณาเลือกพื้นที่ทำงาน', //请选择Base地
    PleaseRecruitmentDepartment: 'กรุณาใส่แผนกที่ประกาศรับ', //请输入招聘部门
    PleaseSelectExpirationTime: 'กรุณาเลือกวันที่สิ้นสุด', //请选择失效时间
    PleaseEnterJobExperience: 'กรุณากรอกประสบการณ์ที่เกี่ยวข้องกับตำแหน่งงาน', //请输入岗位经验
    PleaseEnterJobDescription: 'กรุณากรอกรายละเอียดงาน', //请输入岗位描述
    PleaseSelectJobType: 'กรุณากรอกประเภทงาน', //请选择工作性质
    PleaseEnterJobTitle: 'กรุณากรอกชื่อตำแหน่งงาน', //请输入岗位名称
    PleaseEnterSalaryRange: 'กรุณาระบุช่วงเงินเดือน', //请输入薪资区间
    PleaseSelectEducationalRequirements: 'กรุณาเลือกวุฒิการศึกษาที่ต้องการ', //请选择学历要求

    // 12-22
    promoterNicknameEnglishNumberOnly: 'ใส่ชื่อ-สกุลหรือชื่อเล่นของผู้โปรโมท ใส่ได้เฉพาะภาษาอังกฤษ ตัวเลข ภาษาอังกฤษและตัวเลข เท่านั้น', //填写推广人的姓名或昵称，只能输入英文、数字、英文+数字
    noVideoProduct: 'สินค้านี้ไม่มีวิดีโอ', //该商品暂无视频

    //  12-26
    MerchantWithdrawalFeeSetting: 'ตั้งค่าค่าธรรมเนียมการถอนเงินของร้านค้า:',

    RedEnvelopeEntryQualificatDeadline: 'วันหมดอายุคุณสมบัติอั่งเปา', //红包闯关资格截止日期
    overdueQualificatInvalidRedEnvelopeReward: 'หากไม่สามารถขยายเวลาคุณสมบัติอั่งเปาได้ทันเวลา จะไม่สามารถรับรางวัลอั่งเปาได้อีก', //逾期资格失效，不再获得红包奖励
    totalEligibilityPeriod: 'ระยะเวลาคุณสมบัติที่เหลืออยู่', //资格有效期共计

    netRedTalentTaskSet: 'ตั้งค่าภารกิจอั่งเปาของ KOL MXWINNER', //网红达人闯关任务设置
    GoldRushTalenRedEnvelope: 'ฝ่าด่านพิชิตอั่งเปา MXWINNER', //淘金达人红包闯关
    InternetCelebrityTalentRedEnvelope: 'ฝ่าด่านพิชิตอั่งเปา KOL MXWINNER', //网红达人红包闯关
    netRedTalentRedEnvelopCrossActivityLevelSet: 'ตั้งค่าด่านภารกิจอั่งเปา KOL MXWINNER', //网红达人红包闯关活动关卡设置
    netCelebrityRedEnvelopeQualificatValidPeriod: 'จำกัดระยะเวลาคุณสมบัติอั่งเปาของ KOL MXWINNER', //网红达人红包闯关资格有效期限

    redEnvelopeEligibilityValidityPeriod: 'จำกัดระยะเวลาคุณสมบัติอั่งเปา', //红包资格有效期限
    addedRedEnvelopeQuest: 'เพิ่มภารกิจอั่งเปา', //添加红包闯关任务
    startTime: 'เวลาที่เริ่ม', //起始时间

    NoRelevantInformationUploaded: 'ไม่ได้อัปโหลดข้อมูลดังกล่าว',

    certificationSupplementaryMaterialsSubmittedSuccessful: 'ส่งเอกสารเพิ่มเติมแล้ว จะตรวจสอบเสร็จสิ้นภายใน 48 ชั่วโมง เมื่ออนุมัติแล้วจึงจะสามารถโพสต์สินค้าได้!',

    // 1.6版本 新加
    AddBankAccount: 'เพิ่มบัญชีธนาคาร',//添加银行账户
    BindingType: 'ประเภทการผูกบัญชี',//绑定类型
    BankAccountName: 'ชื่อบัญชี',//银行账户名称
    BankDeposit: 'ธนาคาร',//开户银行
    PassbookAccount: 'เลขที่บัญชี',//存折账号
    PassbookPhoto: 'ภาพหน้าสมุดบัญชี',//存折照片

    // 1-2
    title: 'หัวข้อ',//标题
    Normal: 'ทั่วไป',//普通
    keyPoint: 'จุดที่สำคัญ',//重点
    post: 'ตำแหน่งที่ประกาศ',//发布岗位
    readPeople: 'จำนวนผู้อ่าน',//阅读人数
    amountSingleGiftGoldCoins: 'จำนวนเหรียญที่ส่งได้เพียงครั้งเดียว',//单次赠送金币金额
    amountSingleGiftAmountGoldCoinsDonatedGoldCoins: 'จำนวนเหรียญที่ส่งแล้ว',//已赠送金币金额
    amountSingleGiftAmountGoldCoinsDonatedGoldCoins2: 'จำนวนเหรียญที่ส่ง',//赠送金币金额

    //  1-3
    effectiveTime: 'เวลา ที่ใช้งานได้',
    post: 'โพสต์',
    confirmDeleteData: 'ยืนยันการลบข้อมูลนี้ หรือไม่?', // 确定删除这条数据

    skuCodeNum: 'เลขSKU',

    // 1.6版本 新加
    AddBankAccount: 'เพิ่มบัญชีธนาคาร', //添加银行账户
    BindingType: 'ประเภทการผูกบัญชี', //绑定类型
    BankAccountName: 'ชื่อบัญชี', //银行账户名称
    BankDeposit: 'ธนาคาร', //开户银行
    PassbookAccount: 'เลขที่บัญชี', //存折账号
    PassbookPhoto: 'ภาพหน้าสมุดบัญชี', //存折照片

    // 2-4
    adjustmentOrderNumber: 'เลขที่คำขอ', //调整单号
    documentsAdjustmentShareRatio: 'เอกสารปรับสัดส่วนการแบ่งปันผลกำไร', //分润比例调整单据
    effectiveStartTime: 'วันที่มีผลใช้', //生效起始时间
    effectiveEndTime: 'วันที่สิ้นสุด', //生效结束时间
    adjustQuantityGoods: 'จำนวนสินค้า', //调整商品数量
    proportDistributAdjusted: 'ปรับสัดส่วนการแบ่งปันผลกำไร', //分润比例调整

    passiveTaskOrder: 'คำสั่งซื้อผ่านภารกิจบนแอปฯ', //被动任务订单
    sunOrderNum: 'เลขที่คำสั่งซื้อย่อย', //子订单号
    masterOrderNumber: 'เลขที่คำสั่งซื้อหลัก', //母订单号
    headDevPurRecords: 'ประวัติการซื้อภายใต้หัวหน้าทีม', //团长发展购买记录
    leaderDevReport: 'รายงานการเติบโตของหัวหน้าทีม', //团长发展体系报表
    performanceStatisticsPeriod: 'ระยะเวลาสรุปผลการดำเนินการ', //业绩统计期
    bondUpperLowerTiers: 'วันที่เข้าร่วมทีม', //上下级绑定时间
    upperPhone: 'เบอร์โทรศัพท์ชั้นบน', //上级手机号
    upperNickName: 'ชื่อเล่นชั้นบน', //上级昵称
    userRegistraTime: 'วันที่ลงทะเบียน', //用户注册时间
    buyPhoneNumber: 'เบอร์โทรศัพท์ผู้ซื้อ', //购买人手机号
    NumberItems: 'จำนวนสินค้า', //商品件数
    upper: 'ชั้นบน', //上级
    goldRushAmount: 'ยอด MXGET', //淘金金额
    NumberSubordinates: 'จำนวน User ในชั้นล่าง', //下级人数
    IOrderPeriod: 'จำนวนคำสั่งซื้อของเจ้าของบัญชีในรอบนี้', //本人本期单量
    nextOrderPeriod: 'จำนวนคำสั่งซื้อของคนในทีมในรอบนี้', //下级本期单量
    totalOrdersPeriod: 'จำนวนคำสั่งซื้อทั้งหมดในรอบนี้', //本期总单量
    currentSalesAmount: 'ยอดขายในรอบนี้', //本期销售金额
    periodExpectedPromoteIncentives: 'ยอดคาดการณ์รางวัลการโปรโมทสะสมทั้งหมด', //本期预计推广奖励
    amountRecordePeriod: 'ยอดเงินสะสมที่เข้าบัญชีแล้ว', //本期已入账金额
    numberReturnedItemsPeriod: 'จำนวนการคืนสินค้าทั้งหมด', //本期退货总件数
    amountReturnedPeriod: 'ยอดเงินจากการคืนสินค้าทั้งหมด', //本期退货金额
    accumulatedSingleQuantity: 'จำนวนคำสั่งซื้อสะสมของเจ้าของบัญชี', //本人累计单量
    orderCumulativeSingleQuantity: 'จำนวนคำสั่งซื้อสะสมของคนในทีม', //下级累计单量
    totalCumulativeSingleQuantity: 'คำสั่งซื้อสะสมทั้งหมด', //累计总单量
    cumulativeSalesAmount: 'ยอดขายสะสม', //累计销售金额
    amountEstimatedPromotionIncentives: 'ยอดคาดการณ์รางวัลการโปรโมทสะสมทั้งหมด', //累计预计推广奖励总金额
    cumulativeAmountCredited: 'ยอดเงินสะสมที่เข้าบัญชีแล้ว', //累计已入账金额

    auditor: 'ผู้ตรวจสอบ', //审核人员
    headSysSetup: 'ตั้งค่าการเติบโตของหัวหน้าทีม', //团长发展体系设置
    headSystem: 'การเติบโตของหัวหน้าทีม', //团长发展体系
    headSystemTip: '(เปิดใช้งานเป็นค่าเริ่มต้น Tip: ปุ่มเปิด/ปิดนี้จะส่งผลต่อฟังก์ชันในเมนูรับโบนัสและการแสดงผลบนหน้าแอปพลิเคชัน รายงานการเติบโตของหัวหน้าทีม และประวัติการซื้อ)', //（默认开启状态，提示：该开关涉及APP消费返利及页面展示、运营后台团长发展体系报表、购买记录等功能）

    distriRatioAdjustSheetInformat: 'ข้อมูลเอกสารการปรับสัดส่วนการแบ่งปันผลกำไร', //分润比例调整单信息
    distriRatioAdjustSet: 'ตั้งค่าการปรับการแบ่งปันผลกำไร', //分润调整设置
    adjustedGoods: 'สินค้าที่ปรับสัดส่วนแล้ว', //已调整的商品

    originalPlatformServiceCharge: 'ค่าบริการแพลตฟอร์ม (เดิม)', //原平台服务费
    primaryProportion: 'สัดส่วน (เดิม)', //原占比
    adjustRatio: 'ปรับสัดส่วน(%)', //调整比例(%)
    currentPlatformServiceFee: 'ค่าบริการแพลตฟอร์ม (ปัจจุบัน)', //现平台服务费(฿)
    originalTalentAward: 'รางวัล MXWINNER (เดิม)', //原达人奖励
    talentAward: 'รางวัล MXWINNER (ปัจจุบัน)', //现达人奖励
    ConversionRatio: 'สัดส่วนการแลก', //兑换比例
    AdjustmentOrderNumber: 'เลขที่คำขอ', //调整单号
    totalAmountCurrent: 'ยอดเงินทั้งหมดขณะนี้', //当前账户总金额
    adjustmentRatioCannotEmptyTip: 'ห้ามเว้นว่างในช่องปรับสัดส่วนและค่าบริการแพลตฟอร์ม (ปัจจุบัน)!', //调整比例和现平台服务费不能为空！
    EnteringIncorrectInformationResultTransactionTip: 'การป้อนข้อมูลที่ไม่ถูกต้องจะส่งผลให้ธุรกรรมถูกปฏิเสธ และท่านต้องรับผิดชอบค่าใช้จ่ายใดๆ ที่เกี่ยวข้องกับการดำเนินการตามคำขอของท่าน', //输入不正确的信息将导致交易被拒绝，并且您将承担处理您的请求相关的任何费用

    counted: 'รอคำนวณ', //待统计
    counted2: 'รอสรุปผล', //待结算
    counted3: 'สรุปผลเสร็จสิ้น', //已结算
    bankNotNullTip: 'กรุณาอัปโหลดรูปหน้าแรกสมุดบัญชี!', //请上传存折照片！

    bankPleaseInputNameTip: 'กรุณากรอกชื่อบัญชี', //请输入银行账户名称！
    bankPleaseInputIDCardTip: 'กรุณากรอกเลขบัญชี', //请输入存折账号！
    goBackNum: 'จำนวนสินค้าที่คืน', //退货件数
    goBackMoney: 'ยอดเงินที่คืน', //退货金额
    notFix: 'ไม่สรุปผล', //不结算

    serviceNumIsLong: 'เลขที่บริการต้องไม่เกิน 8 ตัว!', // 服务单号不能超过8位！
    corporateBankAccount: 'บัญชีธนาคารของบริษัท', //  公司银行账户
    PurchasePersonNot: 'สั่งซื้อเองหรือไม่', //是否本人购买
    settlementStatus: 'สถานะการสรุปผล', //结算状态
    settlementStatus1: 'รอสรุปผล', //已统计待结算


    more10Min: "โปรดตั้งเวลาล่วงหน้าอย่างน้อย 10 นาที", // 开始日期需要大于当前时间10分钟后！
    newCategoryDuplicate: "หมวดหมู่สินค้าซ้ำ", //新增分类重复

  }
}



// WEBPACK FOOTER //
// ./src/lang/Thai.js